/**
 * @author  : 王冲
 * @desc    : passport -- 前端登录（含第三方）跳转，登出，TEAMS全局对象管理工具
 */
// @ts-nocheck
import HooksTool from "./hookTools";
import './style/lib.less';
import {
    dealImageUrl, getBrowserLangType,
    getCookie,
    inApp,
    isBackStage,
    isIframeOpen,
    isPageInLockControl,
    isSpPage,
    loadcss,
    setCookie,
    isE10Self, isLoginForbid, isYunTeams,
    isThirdSSO, isLoginTypeEb,
} from "./utils";
import {
    // thirdAppUaReg,
    moduleRouteMap,
    disPlayModuleRouteMap,
    freepassPaths,
    licenseWhiteMap,
    appWhiteMap,
    wsBlackList
} from "./constants";
import {
    loadjs,
    getQueryString,
    isThirdLogin,
    createUUid,
    createTraceId,
    inWxwork,
    isMobileUrl,
    isMobileUA,
    // getHeaderField,
    inMobileApp,
    checkWeappUi,
    getClientType,
    getClientTypeWithoutMobile,
    addDivLog,
    clearOneCookie,
    checkSocketLog,
    // checkSocketDialog,
    inFasterSpPage,
    isProOrBetaEnv,
    inWechat,
    isObstructPage,
    isXinchuang,
    cloneObj,
    getImClientType,
    inCasLogin,
    inIframe,
    getSystemFormatTime
} from "./utils";
declare const window: any;

const publicUrlstatic = window.publicUrlstatic || window.publicUrl || '';
const publicUrlapi = window.publicUrlapi || window.publicUrl || '';
//less文件打包不进来，特别兼容
loadcss(`${publicUrlstatic}/build/passport/static/css/lib.css`);

//给客户端提供标记
window.__ET_WEB_FLAG = true;
if (!window.passport_record) {
    window.passport_record = {}
}
const testAlert = window.alert;
class Passport {
    constructor() {

        if (localStorage.getItem("__TEST_PASSPORT_BREAK_POINT")) {
            alert("__TEST_PASSPORT_BREAK_POINT")
        }

        sessionStorage.removeItem('E10_CASTGC');
        // 集成登录APP跳转
        if (getQueryString('wea_link_keep_loginType') === 'intunifyauth') {
            if (inMobileApp() && getQueryString('wea_link_keep_int_skipApplogin') !== -1) {
                window.location.href = `${publicUrlstatic}/mobile/uk/appLogin`;
            }
        }
        //集成登录保持绕过认证参数
        if (getQueryString('intunifyauth_client') === 'freepass') {
            window.history.replaceState(null, null, window.location.href.replace("intunifyauth_client=freepass", "wea_link_keep_intunifyauth_client=freepass"));
        }
        //集成登录退出登录返回e10登录页参数
        if (getQueryString("wea_link_keep_intunifyauth_logout_return_standard") === 'true'){
            window.history.replaceState(null, null, window.location.href.replace("&wea_link_keep_intunifyauth_logout_return_standard=true", ""));
            this.intunifyLogoutReturnStandard = true;
        }

        //url中存在langType则从中获取
        this.setUrlLangType()

        const whitelistPathReg = /\/freepass/;
        let pathFlag = false;
        if (whitelistPathReg.test(window.location.pathname.replace(publicUrlstatic, ''))) {
            pathFlag = true;
        }
        freepassPaths.forEach(function (path) {
            if (window.location.pathname.indexOf(path) != -1) {
                pathFlag = true;
            }
        });
        const freePass = getQueryString('wea_link_keep_freepass');
        if (freePass === '1') {
            pathFlag = true;
        }

        const eteamsid = getQueryString('eteamsid') || getQueryString('wea_link_keep_tempEteamsId');

        if (eteamsid) {

            window.ETEAMSID = eteamsid;
            try {
                window.opener = null;
            } catch (error) { }

        }
        //外部分发特别处理
        if (window.location.pathname.indexOf('/sp/formreport/distribute') !== -1) {
            const tk = window.location.pathname.replace(publicUrlstatic, '').split('/')[4];
            if (!window.TEAMS) {
                window.TEAMS = {
                    currentTenant: {
                        tenantKey: tk
                    }
                };
            }
        }

        //获取url信息
        window.passport_record.enter = Date.now();
        try {
            if (window.opener?.weappTenantEnv) {
                window.weappTenantEnv = cloneObj(window.opener?.weappTenantEnv);
                this.initGlobalUrlInfo(window.weappTenantEnv);

            } else if (inIframe() && window.parent?.weappTenantEnv) {
                window.weappTenantEnv = cloneObj(window.parent?.weappTenantEnv);
                this.initGlobalUrlInfo(window.weappTenantEnv);
            } else {
                this.getUrlInfo();
            }
        } catch (error) {
            this.getUrlInfo();
        }
        window.passport_record.geturlinfo_end = Date.now();
        if (pathFlag) {
            this.isFreePassUrl = true;
            return;
        }
        if (!window.TEAMS) {
            window.TEAMS = {};
        }
        window.TEAMS.ready = (readyHookName: string, callback: any) => {
            this.hooksTool.getReadyHooks(readyHookName, callback);
        }
        // 本地ls超容监听
        this.runLsMonitor();

        // 获取配置中心登录服务地址

        const redirectModuleSource = getQueryString('redirectModuleSource');
        if (redirectModuleSource) {
            window.redirectModuleSource = redirectModuleSource;
        }
        this.intunifyauthUrlTransfer();
        this.login();

        // 监控服务埋点(api数据监控/登录异常监控)
        this.runLoginMonitor();

        // this.clearFavicon();
    }
    private loginWithTicket: any = false;
    private cssPrefix = 'weapp-frontpassport';
    private logoutTimes = 0;

    private appIsOfflineTest = !!window.localStorage.getItem(`testapp_offline`);
    //ie不兼容问题
    private originServer: string = window.location.protocol + "//" + window.location.host;
    //获取baseserver服务地址
    private baseServer: string = this.originServer + `${publicUrlapi}/api/baseserver`;

    private requestApiNames: any = [];

    private monitorTaskId?: string = "";    //埋点任务id

    private hooksTool: any = new HooksTool();
    //是否是免登地址
    public isFreePassUrl: boolean = false;
    //集成登录退出登录返回e10登录也标记
    public intunifyLogoutReturnStandard = false;

    private passportServer = '';
    //系统退出登录地址
    private sysLogoutUrl = '';

    private weappMonitorInstance: any;

    private pcLocked = false;

    private getInfoError = false;

    private intunifyauthUrlTransfer(skipValidate: boolean) {
        //访问的地址参数中带有intunifyauthTransferUrl参数的，重定向到这个参数地址上
        const intunifyauthTransferUrl = getQueryString("intunifyauthTransferUrl")
        const redirect = () => {
            if (intunifyauthTransferUrl.indexOf("http") === 0) {
                window.location.href = intunifyauthTransferUrl
            } else {
                if (intunifyauthTransferUrl.indexOf(publicUrlstatic) === 0) {
                    window.location.href = intunifyauthTransferUrl
                } else {
                    window.location.href = `${publicUrlstatic}/${intunifyauthTransferUrl}`
                }
            }
        }
        if (intunifyauthTransferUrl && skipValidate) {
            redirect();
        }
        if (intunifyauthTransferUrl && !getQueryString("ticket")) {
            // 检查登录状态
            this.checkEteamsId(false, () => {
                redirect();
            })
        }
    }
    private getUrlInfo() {
        const urlInfoApi = `${publicUrlapi}/papi/app/baseserver/info/getUrlInfo?type=${isMobileUA() ? 'h5' : 'pc'}&service=${encodeURIComponent(this.originServer)}`;
        this.requestApiNames.push(this.originServer + urlInfoApi);
        let getUrlAsync = false;//默认同步
        //解决APP离线本地化或弱网环境部分页面访问问题
        // const urlInfoData = window.localStorage.getItem(`E10_URLINFO_${window.location.host}`);
        // if (inMobileApp() || this.appIsOfflineTest) {
        //     // if (this.appIsOfflineTest) {
        //     if (urlInfoData) {
        //         this.initGlobalUrlInfo(JSON.parse(urlInfoData));
        //         getUrlAsync = true;//改为异步
        //     }
        // }
        this.request({
            type: 'GET',
            url: urlInfoApi,
            async: getUrlAsync,
            callback: (responseText: any) => {//TODO确认
                try {

                    let data = JSON.parse(responseText);

                    if (!isProOrBetaEnv()) {
                        if ((inMobileApp() && data?.data) || this.appIsOfflineTest) {
                            // if (this.appIsOfflineTest) {
                            const compareData = JSON.stringify(data.data);
                            window.localStorage.setItem(`E10_URLINFO_${window.location.host}`, compareData);

                            // if (urlInfoData && compareData !== urlInfoData) {
                            //     if (window.location.host.indexOf('e-cology.com.cn') === -1) {
                            //         window.location.reload();
                            //     }
                            // }
                        }
                    }
                    if (data?.data) {
                        this.initGlobalUrlInfo(data.data);
                        //集成登录参数控制返回e10登录页
                        if (this.intunifyLogoutReturnStandard){
                            clearOneCookie('caslogouturl');
                        }
                    }

                    //埋点记录：urlInfo获取异常
                    if (data?.code != 200) {
                        this.addAsyncMonitorTask({
                            type: "passport_login_getUrlInfo",
                            taskData: {
                                code: data.code,
                                msg: data.msg
                            },
                            des: 'urlInfo获取异常'
                        })
                    }
                } catch (error) {
                    // this.addAsyncMonitorTask({
                    //     type: "passport_login_getUrlInfo",
                    //     taskData: {
                    //         code: '',
                    //         msg: ''
                    //     },
                    //     des: 'urlInfo获取异常'
                    // })
                }
            }
        });
    }
    private checkWsBlackList() {
        return wsBlackList.some((it) => {
            return window.location.pathname.indexOf(it) !== -1;
        })
    }

    private runLsMonitor() {
        window.addEventListener('error', (e: any) => {
            const errorName = e?.error?.name;
            // console.info(e, errorName)
            if (this.isLocalstorageExceedError(errorName) && !window.locallsOversize) {
                console.log('ls超容');
                window.locallsOversize = true;
                this.showClearPrompt();
            }
        });
    }

    private isLocalstorageExceedError(errorName) {
        return (
            errorName == 'QuotaExceededError' ||  //chrome
            errorName == 'NS_ERROR_DOM_QUOTA_REACHED' //firefox
        )
    }

    public showClearPrompt() {
        let clearLs = () => {
            let regs = [
                /^(?=leftmenu_)/,
                /^(?=weapp-em-message-tool-menus)/,
                /^(?=LAYOUT_NAV_MENU)/,
                /^(?=ebPageCache_)/,
                /^(?=weapp-em-message-menus-)/,
                /^(?=E10_TEAMS_LOCAL)/,
                /^(?=cusapp_storage_)/,
                /^(?=edata-)/,
                /^(?=portal-)/,
                /^(?=tabdata-)/
                // /(?=.*crm)(?=.*columnResize)/ //待定
            ]
            //清理非必须ls缓存
            Object.keys(window.localStorage).forEach(function (key) {
                regs.forEach(function (reg) {
                    if (reg.test(key)) {
                        window.localStorage.removeItem(key);
                    }
                });
            })
            window.location.reload();
        }
        checkWeappUi(() => {
            let tit = window.weappUtils.getLabel('15976', '提示信息'),
                msg = window.weappUtils.getLabel('151579', '您当前页面缓存过多，为了避免系统功能使用异常，请您确认清理缓存并刷新页面！')
            if (isMobileUA() || isMobileUrl()) {
                window.weappUi.MDialog.prompt({
                    title: tit,
                    mask: true,
                    maskClosable: true,
                    message: msg,
                    onClose: function () { },
                    onOk: function () { clearLs() },
                    prompt: false,
                })
            } else {
                window.weappUi.Dialog.confirm({
                    content: msg,
                    onOk: function () { clearLs() },
                    onCancel: function () { },
                });
            }
        });
    }


    //地址匹配
    private pathMapMathed(pathsMap: any, currentPath?: string) {
        let flag = false;
        currentPath = currentPath && typeof (currentPath) === 'string' ? currentPath : window.location.pathname.replace(publicUrlstatic, '');//增加自定义传入path
        pathsMap.forEach(function (path: any) {
            if (currentPath.indexOf(path) == 0) {
                flag = true;
            }
        });
        return flag;
    }
    //全局域名配置
    private initGlobalUrlInfo(data: any) {
        window.weappTenantEnv = data;
        if (data.passportUrl) {
            this.passportServer = data.passportUrl;
        }
        if (data["sysDefaultLogoutUrl "] || data.sysDefaultLogoutUrl){
            this.sysLogoutUrl = data["sysDefaultLogoutUrl "] || data.sysDefaultLogoutUrl;
        }
        if (window.localStorage.getItem('layoutlogin')) {
            window.weappTenantEnv.loginPrivateUrl = true;
        }
    }

    // 数据监控
    private runLoginMonitor() {
        const monitorListen = (e: any) => {
            if (e?.detail?.weappMonitorInstance) {
                this.weappMonitorInstance = e.detail.weappMonitorInstance;
                this.hooksTool.getReadySuccessHook("utilsReady");
            }
        }
        window.addEventListener('weappMonitorInstanceInited', monitorListen)
    }

    //添加异步数据监控任务
    private addAsyncMonitorTask(taskData: any) {
        this.hooksTool.getReadyHooks("utilsReady", {
            success: function () {
                if (this.weappMonitorInstance) {
                    taskData.module = "passport";
                    if (this.monitorTaskId) {
                        taskData.taskId = this.monitorTaskId;
                    }
                    const taskId = this.weappMonitorInstance.addTask("custom", taskData);
                    if (!this.monitorTaskId) {
                        this.monitorTaskId = taskId;
                    }
                }
            }
        })
    }

    // 第三方登录跳转--同步
    private thirdLogin() {
        let href = window.location.href,
            origin = this.originServer;
        let urlArr = href.split('?');
        let loginURL = origin + '/papi/app/eb/oauth/authlink/'
            + createUUid()
            + '?ebTargetUrl='
            + urlArr[0]
            + (urlArr[1] ? ('&' + urlArr[1]) : '');
        window.location.href = loginURL;
    }
    //兼容云桥老跳转逻辑
    private disPatchebAuthCheck() {
        const code = getQueryString('code');
        // 有 code 则可以直接请求同步接口，code由企微生成
        if (code) {
            window.ebAuthChecking = true;
            window.passport_record.ebCheck_start = Date.now();
            const { protocol, hostname, port, pathname } = window.location;
            const origin = `${protocol}//${hostname}${port ? ':' + port : ''}`;

            let url = `/papi/app/eb/oauth/asyncLink${window.location.search}&redirectUrl=${encodeURIComponent(origin + pathname)}`;
            window.passport_record.ebCheck_url = url;
            window.TEAMS.async = this.ebAsyncAuth;
            this.request({
                type: 'GET',
                url: url,
                async: this.ebAsyncAuth,
                callback: (responseText) => {
                    window.passport_record.ebCheck_responseText = responseText;
                    window.passport_record.ebCheck_end = Date.now();
                    try {
                        const data = JSON.parse(responseText);
                        if (data?.data?.eteamsid) {
                            //这两行可去掉，待验证
                            window.ETEAMSID = data.data.eteamsid;
                            setCookie('ETEAMSID', data.data.eteamsid);
                            this.checkEteamsId();
                            this.fetchTEAMS();
                        }
                        // this.hooksTool.getReadySuccessHook('authChecked', {
                        //     type: 'ebridge',
                        //     data: data
                        // });
                    } catch (err) {
                        // this.hooksTool.getReadySuccessHook('authChecked', {
                        //     type: 'ebridge',
                        //     data: err
                        // });
                        console.error('[asyncLink catch]: ', err);
                    }
                }
            })
        } else {
            this.fetchTEAMS();//原逻辑，由接口返回code判断
        }
    }
    //第三方登录跳转
    private ebAuthCheck() {
        loadjs('/build/ebutils/static/js/lib.js', () => {
            window.ebutils?.ebAuthCheck(
                (res: any) => {
                    let mark = getQueryString('wea_link_keep_async');
                    if (!(mark && mark == '1')) {
                        this.thirdLogin();
                    }
                },
                false
            )
            !window.ebutils && this.addAsyncMonitorTask({
                type: "passport_login_loadEbutils",
                taskData: {
                    ua: window.navigator.userAgent,
                    href: window.location.href
                },
                des: 'ebutils加载异常'
            })
        })
    }
    private frameToken: string = ''
    private getTokenFromPostMsg() {
        window.addEventListener("message", (event) => {
            let data = event.data;
            if (data?.key === 'Token') {
                let thirdToken = data.value;
                this.frameToken = data.value;
                let params = new FormData();
                params.append('thirdToken', thirdToken);
                this.request({
                    type: 'POST',
                    params: params,
                    dataType: 'formData',
                    url: `${publicUrlapi}/papi/app/baseserver/info/getInfo`,
                    callback: (responseText: any, status) => {
                        try {
                            const data = JSON.parse(responseText);
                            const cks = data?.data || {};
                            if (status !== 200 || data?.code !== 200) {
                                checkWeappUi(() => {
                                    window.weappUi.Dialog.message({
                                        content: 'system error, try again later'
                                    });
                                });
                                return;
                            }
                            if (cks['ACCESS_ETEAMSID']) {
                                window.ETEAMSID = cks['ACCESS_ETEAMSID'];
                                window.location.reload();
                            } else {
                                if (getQueryString('wea_link_keep_nsAuth')) {
                                    if (this.frameToken) {
                                        checkWeappUi(() => {
                                            window.weappUi.Dialog.message({
                                                content: 'invalid token'
                                            });
                                        });
                                    }
                                }
                            }
                        } catch (error) {

                        }
                    }

                })
            }
        })
        window.top.postMessage({ key: "RefreshToken" }, '*');
    }

    private request(options: any) {
        // if (window.ebAuthChecking) return;
        let traceId = createTraceId();
        let type = options.type,
            url = options.url,
            cb = options.callback,
            async = options.async,
            params = options.params,
            dataType = options.dataType || '',
            hookcb = options.hookcb;
        if (!options.async) {
            async = false;//默认同步
        }
        let asyncLoaded = false;
        let xhr = new XMLHttpRequest();
        let traceIdSwitchStatus = localStorage.getItem('weappMonitorTraceIdSwitchStatus') === 'true' ? true : false;
        if (traceIdSwitchStatus) {
            url += ((url || '').indexOf('?') > -1 ? '&' : '?') + 'weappmonitor_traceId=' + traceId;
        }
        xhr.open(type, url, async);
        if (dataType !== 'formData') {
            xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
            xhr.setRequestHeader('accept', 'application/json, text/plain, */*');
            xhr.setRequestHeader('traceid', traceId);
        }

        if (window.ETEAMSID) {
            xhr.setRequestHeader('ETEAMSID', window.ETEAMSID);
        }
        if (this.tempEteamsId) {
            xhr.setRequestHeader('ETEAMSID', this.tempEteamsId);
        }
        if (isThirdLogin()) {
            xhr.setRequestHeader('currentUrl', window.location.href);
        }
        xhr.withCredentials = true;
        try {

            if (params) {
                if (dataType === 'formData') {
                    xhr.send(params);
                } else {
                    xhr.send(JSON.stringify(params));
                }
            } else {
                xhr.send();
            }
        } catch (e) {
            console.info(e)
        }
        if (typeof cb === 'boolean') {
            async = cb;
            cb = null;
        }
        const checkAuth = (responseText: any) => {
            try {
                let res = JSON.parse(responseText);
                if (res.code === 20220610 && !window.ebAuthChecking) {
                    window.ebAuthChecking = true;
                    this.ebAuthCheck();
                    return;
                }
                if (res.code === 20221104 && !window.intAuthChecking) {
                    window.intAuthChecking = true;
                    if (res.data?.loginurl) {
                        window.location.href = res.data.loginurl;
                    }
                }
            } catch (e) {
                hookcb && hookcb();
                localStorage.setItem('tt', 1);
            }
            cb && cb(xhr.responseText, xhr.status)
        }
        if (async) {
            xhr.onreadystatechange = function () {
                if (xhr.readyState == 4) {
                    asyncLoaded = true;
                    checkAuth(xhr.responseText);
                }
                // // 一秒不执行兜底处理
                // setTimeout(() => {
                //     time++;
                //     if (time > 60 && !loaded) {
                //         cb && cb(xhr.responseText)
                //     }
                // }, 1000);
            }
        } else {
            if (localStorage.getItem('eteamsid_test')) {
                xhr.onreadystatechange = function () {
                    console.log(xhr.responseText)
                }
            }

            checkAuth(xhr.responseText);
        }
    }

    private websocketConnection: any;

    //提下线
    public websocketSDK = {

    }


    private runWebsocket() {
        const client = getClientTypeWithoutMobile();
        if (!client) {
            return;
        }

        const ran = createTraceId();
        let protocol = window.location.href.indexOf('https://') === 0 ? 'wss' : 'ws', url;
        let host = window.location.host;
        if (window.weappTenantEnv?.onlineDomianUrl) {
            const domainurl = window.weappTenantEnv?.onlineDomianUrl;
            if (domainurl.indexOf('http://') === 0 || domainurl.indexOf('https://') === 0) {
                protocol = domainurl.indexOf('https://') === 0 ? 'wss' : 'ws';
                host = domainurl.split('//')[1];
            }
        }
        url = `${protocol}://${host}${publicUrlapi}/api/online/webSocket?dtu=${client}&userId=${window.btoa(window.TEAMS?.currentUser?.userId)}&ran=${ran}`;

        let connecting = false;

        const runWs = () => {
            const showKickDialog = (options: any) => {
                // if (!checkSocketDialog()) {
                //     return
                // }
                let offlineTime: any;
                checkWeappUi(() => {
                    if (options.time) {
                        offlineTime = getSystemFormatTime(options.time, 0)
                    }
                    if (!document.querySelector('#ws_bekick')) {
                        const div = document.createElement('div');
                        div.setAttribute('id', 'ws_bekick');
                        document.body.appendChild(div);
                    }

                    const { Dialog, Icon, Button } = window.weappUi;
                    const { getLabel } = window.weappUtils;
                    // const kickTime = `2022-11-26 16:49:16`;
                    if (window.ReactDOM) {
                        window.ReactDOM.render(React.createElement(Dialog, {
                            visible: true,
                            mask: true,
                            title: getLabel('171667', '下线通知'),
                            width: 600,
                            wrapClassName: `${this.cssPrefix}-kick`
                        }, React.createElement("div", {
                            className: `${this.cssPrefix}-kick-icon`
                        }, React.createElement(Icon, {
                            name: `Icon-empty-No-permission-notification`
                        })), React.createElement("div", {
                            className: `${this.cssPrefix}-kick-dec`
                        }, getLabel('171668', '您的账号于{0}登入，如非本人操作，则密码可能已泄漏，建议修改密码。', [offlineTime])),
                            React.createElement("div", {
                                className: `${this.cssPrefix}-kick-btn`
                            }, React.createElement(Button, {
                                type: "warning",
                                onClick: () => this.logout()
                            }, getLabel('171669', '返回登录界面')))), document.getElementById('ws_bekick'));
                    }

                })
            }

            if (window.WebSocket) {
                connecting = true;
                let connection: any = new WebSocket(url);
                this.websocketConnection = connection;

                if (localStorage.getItem("TEST_WS_SOCKET")) {
                    window.TEST_WS_SOCKET = connection;
                }

                let beatStarted = false;
                let headParams = {
                    userId: window.TEAMS?.currentUser?.userId,
                    eteamsId: window.ETEAMSID,
                    time: new Date().getTime()
                }
                let channelId = '';

                let beat = () => {
                    const beatFun = () => {
                        const message = {
                            head: {
                                label: 'heart_beat',
                                ...headParams,
                                eteamsId: window.ETEAMSID
                            },
                            body: {}
                        }
                        if (beatStarted) {
                            if (checkSocketLog()) {
                                addDivLog(`发送心跳------${JSON.stringify(message)}`)
                            }
                            connection.send(JSON.stringify(message));
                            let timer = setTimeout(() => {
                                beat()
                                clearTimeout(timer)
                            }, 70000)
                        }
                    }

                    if (this.useTempToken) {
                        beatFun();
                    } else {
                        //尝试缓存获取一次
                        const eteamsId = this.getETEAMSID();
                        let testHttpOnly = window.localStorage.getItem("TEST_PASSPORT_HTTPONLY");
                        if (eteamsId && !testHttpOnly) {
                            window.ETEAMSID = eteamsId;
                            beatFun();
                        } else {
                            this.checkEteamsId(true, () => {
                                beatFun();
                            });
                        }
                    }
                }
                connection.onopen = (event: any) => {
                    connecting = false;
                    console.log('Connected to: ' + event.currentTarget.URL);
                };

                connection.onmessage = (evt: any) => {
                    console.log("数据已接收..." + evt.data);
                    let message: any = {}, data = JSON.parse(evt.data);
                    const label = data.head.label;
                    const body = data.body;
                    switch (label) {

                        case 'trigger_heart':
                            beatStarted = true;
                            beat();
                            break;
                        case 'conn_success_req':
                            message = {
                                head: {
                                    label: 'conn_success',
                                    ...headParams
                                }, body: {}
                            }
                            channelId = data.body.channelId;
                            connection.send(JSON.stringify(message));
                            break;
                        case 'xincForce_offlineNotify':

                            message = {
                                head: {
                                    label: 'conn_xincNotify',
                                    ...headParams
                                }, body: {}
                            }
                            if (!isXinchuang() && !isMobileUA() && !window.TEAMS?.currentUser?.admin) {
                                connection.send(JSON.stringify(message));
                            }
                            break;
                        //踢目标下线
                        case 'conn_kick_req':
                            message = {
                                head: {
                                    label: 'conn_kick',
                                    ...headParams
                                }, body: {

                                }
                            }
                            // if (checkSocketDialog()) {
                            checkWeappUi(() => {
                                const { getLabel } = window.weappUtils;
                                window.weappUi.Dialog.confirm({
                                    title: getLabel('171670', '该账号已在其他设备登录'),
                                    content: getLabel('171671', '继续登录会下线其他设备的账号，确认登录吗？'),
                                    cancelText: getLabel('171672', '退出'),
                                    onOk: () => {
                                        message.body.targetId = data?.body.repeatId;
                                        connection.send(JSON.stringify(message));
                                    },
                                    onCancel: () => {
                                        connection.close();
                                        window.ePassport?.logout();
                                    }
                                });
                            })
                            // }
                            break;

                        //pc锁定
                        case 'page_lock':
                            console.info("==ws_page_lock==")
                            if (isPageInLockControl()) {
                                this.showPcLock();
                                this.pcLocked = true;
                                if (window.TEAMS?.pageLockInfo?.lockStatus) {
                                    window.TEAMS.pageLockInfo.lockStatus = "LOCK";
                                }
                            }
                            break;
                        //pc解锁
                        case 'page_unlock':
                            console.info("==page_unlock==")
                            if (isPageInLockControl()) {
                                this.contentDom && document.body.appendChild(this.contentDom);
                                this.contentDom = null;
                                this.pcLocked = false;
                                if (window.TEAMS?.pageLockInfo?.lockStatus) {
                                    window.TEAMS.pageLockInfo.lockStatus = "NO_LOCK";
                                }
                                this.lockPageDom && document.body.removeChild(this.lockPageDom);
                            }
                            break;
                        case "remove_bindOffline":
                            window.ePassport?.logout();
                            break;
                        case "update_accountInfo":
                            window.ePassport?.logout();
                            break;
                        case "open_sysLogout":
                            this.passportRedirect('logout')
                            break;
                        case "custom_msg":
                            // body = {
                            //     "head": {
                            //         "label": "appManageSync"
                            //     },
                            //     "body": {
                            //         "message": ""
                            //     }
                            // }
                            const bodyObj = JSON.parse(body);
                            if (bodyObj && bodyObj.head?.label === 'appManageSync') {
                                const remindBydy = bodyObj.body;
                                const message = remindBydy?.message || "";
                                const status = remindBydy?.asyncStatus || "0";
                                let messageType = "info";
                                if (status === '1') {
                                    messageType = "success"
                                }
                                checkWeappUi(() => {
                                    window.weappUi.Dialog.message({
                                        type: messageType,
                                        content: message,
                                    });
                                });
                            }
                            break;
                    }

                };

                connection.onclose = (event: any) => {
                    if (checkSocketLog()) {
                        addDivLog(`链接已关闭`)
                    }
                    beatStarted = false;//断开定时器执行
                    let timer: any;
                    // console.log("连接已关闭...");
                    const rebuild = () => {
                        timer = setTimeout(() => {
                            clearTimeout(timer);
                            runWs();
                        }, 6000);
                    }
                    let timer2 = setTimeout(() => {
                        if (channelId) {
                            this.request({
                                type: 'POST',
                                url: `${this.originServer}${publicUrlapi}/papi/basiconline/offline/qryDisConnInfo`,
                                async: true,
                                params: {
                                    channelId
                                },
                                callback: (responseText: any) => {
                                    try {
                                        let res = JSON.parse(responseText);
                                        if (checkSocketLog()) {
                                            addDivLog(`重连${responseText}`)
                                        }
                                        if (res.code === 200 && res.data?.info) {
                                            const label = res.data?.info.breakLabel;
                                            const repeat = res.data?.repeat;
                                            switch (label) {
                                                case 'conn_bekick':
                                                    //非正式beta环境
                                                    // if (!isProOrBetaEnv()) {
                                                    showKickDialog({ time: res.data.time });
                                                    // }
                                                    break
                                                case 'exit_conn':
                                                    this.logoutFunc();
                                                    break
                                                // case 'eteamsId_notMatch':
                                                //     if (!document.querySelector('#reloginDialog')) {
                                                //         window.location.reload();
                                                //     }
                                                //     break
                                                case 'exit_login':
                                                    window.location.reload();
                                                    break
                                                case 'alert_connAccount':   //账号修改踢下线
                                                    try {
                                                        window.open("", "_self").close();
                                                    } catch (error) { }
                                                    break
                                                case 'change_team': //切换团队刷新
                                                    window.location.reload();
                                                    break
                                                case 'force_offline':    //管理员强制下线
                                                    checkWeappUi(() => {
                                                        // if (!checkSocketDialog()) {
                                                        //     return
                                                        // }
                                                        if (!document.querySelector('#ws_force_offline')) {
                                                            const div = document.createElement('div');
                                                            div.setAttribute('id', 'ws_force_offline');
                                                            document.body.appendChild(div);
                                                        }
                                                        const { Dialog, Icon, Button } = window.weappUi;
                                                        const { getLabel } = window.weappUtils;
                                                        if (window.ReactDOM) {
                                                            window.ReactDOM.render(React.createElement(Dialog, {
                                                                visible: true,
                                                                mask: true,
                                                                title: getLabel('171667', '下线通知'),
                                                                width: 600,
                                                                wrapClassName: `${this.cssPrefix}-kick`
                                                            }, React.createElement("div", {
                                                                className: `${this.cssPrefix}-kick-icon`
                                                            }, React.createElement(Icon, {
                                                                name: `Icon-empty-No-permission-notification`
                                                            })), React.createElement("div", {
                                                                className: `${this.cssPrefix}-kick-dec`
                                                            }, getLabel('171673', '您已被管理员强制下线')),
                                                                React.createElement("div", {
                                                                    className: `${this.cssPrefix}-kick-btn`
                                                                }, React.createElement(Button, {
                                                                    type: "warning",
                                                                    onClick: () => this.logout()
                                                                }, getLabel('171669', '返回登录界面')))), document.getElementById('ws_force_offline'));
                                                        }
                                                    });
                                                    break
                                                case 'conn_repeat': //重复链接重新
                                                    repeat && rebuild()
                                                    break
                                                // 登录过期不拦截由网关+前端request触发
                                                case 'session_expired': //登录过期
                                                    // this.logout();
                                                    break
                                                case 'conn_toomany':    //链接过多
                                                    repeat && rebuild()
                                                    break
                                                case 'nofound_heart':   //没有收到心跳
                                                    repeat && rebuild()
                                                    break
                                                case 'conn_xincNotify':     //信创下线
                                                    this.logout();
                                                    break
                                                case 'remove_bindOffline':  //解除账号绑定踢下线
                                                    this.logout();
                                                    break
                                                case 'remoteForce_offline': //远程强制下线
                                                    const { labelId = '0' } = res.data.info.body;
                                                    const params = {
                                                        "type": window.TEAMS?.locale?.lang || 'zh_CN',
                                                        "labelId": labelId,
                                                        "tenantKey": window.TEAMS?.currentTenant?.tenantKey
                                                    }
                                                    this.request({
                                                        type: 'POST',
                                                        url: `${this.originServer}${publicUrlapi}/papi/basiconline/offline/translate`,
                                                        async: true,
                                                        params: params,
                                                        callback: (responseText: any) => {
                                                            try {
                                                                const res = JSON.parse(responseText);
                                                                if (res?.data?.result) {
                                                                    const msg = res?.data?.result;
                                                                    checkWeappUi(() => {
                                                                        if (!document.querySelector('#ws_remoteForce_offline')) {
                                                                            const div = document.createElement('div');
                                                                            div.setAttribute('id', 'ws_remoteForce_offline');
                                                                            document.body.appendChild(div);
                                                                        }
                                                                        const { Dialog, Icon, Button } = window.weappUi;
                                                                        const { getLabel } = window.weappUtils;
                                                                        if (window.ReactDOM) {
                                                                            window.ReactDOM.render(React.createElement(Dialog, {
                                                                                visible: true,
                                                                                mask: true,
                                                                                title: getLabel('171667', '下线通知'),
                                                                                width: 600,
                                                                                wrapClassName: `${this.cssPrefix}-kick`
                                                                            }, React.createElement("div", {
                                                                                className: `${this.cssPrefix}-kick-icon`
                                                                            }, React.createElement(Icon, {
                                                                                name: `Icon-empty-No-permission-notification`
                                                                            })), React.createElement("div", {
                                                                                className: `${this.cssPrefix}-kick-dec`
                                                                            }, msg),
                                                                                React.createElement("div", {
                                                                                    className: `${this.cssPrefix}-kick-btn`
                                                                                }, React.createElement(Button, {
                                                                                    type: "warning",
                                                                                    onClick: () => this.logout()
                                                                                }, getLabel('171669', '返回登录界面')))), document.getElementById('ws_remoteForce_offline'));
                                                                        }
                                                                    });
                                                                }

                                                            } catch (error) {

                                                            }

                                                        }
                                                    })

                                                    break
                                            }

                                        } else {    //后端你返回错误重连

                                        }
                                    } catch (e) {   //js错误情况重连
                                        rebuild()
                                    }
                                },
                                fail: () => {       //错误情况重连
                                    rebuild()
                                }
                            })
                        }
                        clearTimeout(timer2)
                    }, 6000)

                };

                connection.onerror = (event: any) => {
                    console.info("连接错误");
                }
            } else {
                console.log("您的浏览器不支持 WebSocket!");
            }

        }
        const runWsMonitor = () => {
            window.addEventListener("mousemove", (e) => {
                if (!connecting && this.websocketConnection?.readyState === 3) {
                    if (!window.weappPassport?.lastOnlineRebuildTime || new Date().getTime() - window.weappPassport?.lastOnlineRebuildTime > 10 * 1000) {
                        window.weappPassport.lastOnlineRebuildTime = new Date().getTime();
                        runWs();
                    }
                }
            })
        }
        runWs();
        runWsMonitor();
    }

    private showSystemError(params: any = {}) {
        const { content = '', showType = 'page', errorType } = params;
        if (showType === 'message') {
            checkWeappUi(() => {
                if (isMobileUA() || isMobileUrl()) {
                    window.weappUi?.MDialog?.toast({
                        content: content
                    })
                } else {
                    window.weappUi?.Dialog?.message({
                        type: `error`,
                        content: content
                    })
                }
            });
            return
        }
        if (isMobileUA() || isMobileUrl()) {
            const isSystemErrorPage = window.location.href?.indexOf('/mobile/uk/systemerrortip') > -1;
            if (!isSystemErrorPage) {
                window.location.href = `${publicUrlstatic}/mobile/uk/systemerrortip?errortype=${errorType}`
            }
        } else if (isSpPage()) {
            const isSystemErrorPage = window.location.href?.indexOf('/info/systemerrortip') > -1;
            if (!isSystemErrorPage) {
                window.location.href = `${publicUrlstatic}/info/systemerrortip?errortype=${errorType}`;
            }
        } else {
            window.showSystemError = {
                visible: true,
            };
        }
    }

    //获取TEAMS
    private fetchTEAMS(withTicket?: boolean) {

        if (isYunTeams()) {
            if (!isMobileUA()) {
                //登录拦截检查
                this.checkLoginForbid();

                if (isObstructPage()) {
                    return;
                }
            }
        }

        let async = false;
        let skipRequst = false;//跳过请求
        let lsTEAMSKey = 'E10_TEAMS_LOCAL';
        let lastTEAMS = window.localStorage.getItem(lsTEAMSKey) || null;

        if ((!withTicket && isMobileUrl()) || isSpPage()) {
            console.info('check-1');
            try {
                let obstructPage = window.location.href.indexOf('/obstruct/') !== -1;
                //从父页面打开,这里个别环境跨域报错
                if (((inIframe() && window.parent.TEAMS) || (window.opener?.TEAMS && window.opener?.TEAMS?.currentUser)) && isSpPage() && !this.useTempToken && !window.weappTenantEnv?.spCacheOpen) {
                    skipRequst = true;
                    let teamsData: any = null;
                    if (window.opener?.TEAMS) {
                        teamsData = lastTEAMS || JSON.stringify(window.opener?.TEAMS);
                    } else {
                        teamsData = JSON.stringify(window.parent.TEAMS);
                    }
                    window.TEAMS = {
                        ...JSON.parse(teamsData),
                        ready: window.TEAMS.ready
                    };
                    // this.extendTEAMS();
                } else if ((lastTEAMS && !isSpPage() && isMobileUA() && !obstructPage) || (isSpPage() && window.weappTenantEnv?.spCacheOpen && !obstructPage)) {
                    async = true;
                    window.TEAMS = {
                        ...JSON.parse(lastTEAMS),
                        ready: window.TEAMS.ready
                    };
                    // this.extendTEAMS();
                } else if (this.ebAsyncAuth) {
                    async = true;
                }
            } catch (error) {
                if (lastTEAMS && !isSpPage()) {
                    async = true;
                    window.TEAMS = {
                        ...JSON.parse(lastTEAMS),
                        ready: window.TEAMS.ready
                    };
                    // this.extendTEAMS();
                } else {
                    window.TEAMS = {
                        ready: (readyHookName: string, callback: any) => {
                            this.hooksTool.getReadyHooks(readyHookName, callback);
                        }
                    };
                    async = false;
                }
            }
        } else if (this.ebAsyncAuth) {
            // console.info('check-2');
            async = true;
        }
        window.TEAMS.async = async;
        let apiName = this.getTEAMSapi();
        // var ebParams = null;
        // console.log(apiName,withTicket)
        this.requestApiNames.push(apiName);
        // if (isThirdLogin()) {
        //     ebParams = that.getSearchParams();
        // }
        // 异步
        if (!this.ebAsyncAuth && (async || skipRequst)) {
            this.afterFetchTeams({ async, skipRequst, lastTEAMS });
        }

        if (!skipRequst) {
            window.passport_record[`teams_start_async_${async ? 1 : 0}`] = Date.now();
            this.request({
                type: 'POST',
                url: this.getTEAMSapi(),
                // params:ebParams,
                callback: (responseText: any) => {
                    try {
                        const TEAMS = JSON.parse(responseText);
                        // if (TEAMS?.tenantLogo?.faviconUrl){
                        //     TEAMS.tenantLogo.faviconUrl = TEAMS.tenantLogo.faviconUrl + "?v=" + new Date().getTime()
                        // }
                        window.TEAMS = {
                            ...TEAMS,
                            ready: window.TEAMS?.ready,
                            async: async
                        };
                        this.afterFetchTeams({ async, skipRequst, lastTEAMS, responseText });
                        if (window.localStorage.getItem('E10_passport_testError')) {
                            this.showSystemError({ errorType: 'E10_passport_testError' });
                        }
                        window.passport_record[`teams_end_async_${async ? 1 : 0}`] = Date.now();
                    } catch (error) {
                        // 系统异常
                        try {
                            window.localStorage.setItem("E10_PASSPORT_ERROR_INFO", JSON.stringify(error));
                        } catch (e) {
                        }
                        this.showSystemError({ errorType: 'js_error' });
                    }

                },
                async: async
            });

        }
    }
    private getTEAMSapi() {
        let inPCClient = /weapp-pc/i.test(window.navigator.userAgent)
        let apiParams = [];
        // if (window.ETEAMSID) {
        //     apiParams.push(`ETEAMSID=${window.ETEAMSID}`)
        // }
        if (this.useTempToken && window.ETEAMSID) {
            apiParams.push(`ETEAMSID=${window.ETEAMSID}`)
        }
        if (inPCClient) {    //客户端下增加主题客户端参数
            apiParams.push(`dtu=app-pc`)
        }
        if (!isXinchuang() && !isMobileUA()) {//非信创环境 &&非mobile 开启拦截查询
            apiParams.push(`clientType=not_xinchuang`)
        }
        if (getQueryString("wea_link_keep_topicid")) {   //特色主题预览
            apiParams.push(`topicId=${getQueryString("wea_link_keep_topicid")}`)
        }

        if (window.TEAMS?.checkToken) {
            apiParams.push(`checkToken=${window.TEAMS?.checkToken}`)
        }

        return `${this.baseServer}/layout/teamsCheck${apiParams.length > 0 ? `?${apiParams.join("&")}` : ``}`;
    }
    public checkLoginForbid() {
        let apiName = `${this.originServer}/papi/baseserver/layout/check`;
        let checkToken = getQueryString("checkToken");
        if (checkToken) {
            apiName = apiName + '?checkToken=' + checkToken;
        }

        this.request({
            type: 'POST',
            url: apiName,
            callback: (responseText: any) => {
                try {
                    const data = JSON.parse(responseText);
                    if (data?.status) {

                        window.TEAMS = {
                            ...(window.TEAMS || {}),
                            ...(data.data || {})
                        }

                        this.loginForbidRedirect()
                    }
                } catch (error) {
                }
            },
            async: false
        });
    }

    loginForbidRedirect = () => {
        if (window.location.href.indexOf('/obstruct/') == -1) {

            //当前登入方式不支持、登录账号设置拦截
            if (isObstructPage()) {
                const isRealNameObstruct = (window.TEAMS?.realNameConfig?.forceAuth && !window.TEAMS?.realNameConfig?.hasAuth && !window.TEAMS?.realNameConfig?.white)
                let unRedirect = false
                if (isRealNameObstruct) {
                    const setUnRedirect = () => {
                        if (!(isLoginForbid() ||
                            window.TEAMS?.loginAccess === false ||
                            window.TEAMS?.firstLoginUpdatePassword === true ||
                            window.TEAMS?.forceUpdatePassword === true ||
                            window.TEAMS?.customLoginForbid === true)) {
                            unRedirect = true
                            return
                        }
                    }
                    this.request({
                        type: 'POST',
                        url: `${publicUrlapi}/api/basicserver/realnameAuth/initAuth`,
                        async: false,
                        params: {
                            loginPageUrl: window?.location?.origin,
                            sysPageUrl: window?.location?.origin,
                            forceAuth: "E",
                            syncBack: "E"
                        },
                        callback: (res: any) => {
                            try {
                                res = JSON.parse(res)
                                if (res.code == 508 || !res?.data?.authUrl) {
                                    setUnRedirect()
                                }
                            } catch (error) {
                                setUnRedirect()
                            }
                        },
                        fail: () => {
                            setUnRedirect()
                        }
                    })
                }
                if (unRedirect) {
                    return
                }
                //白名单页面允许访问
                const obstructWhiteFlag = '?wea_link_keep_obstruct_pass=true'
                const obstructWhiteList = [`/mobile/uk/createteam`, `/mobile/uk/teams/join`]
                const isWhite = window.location.search?.indexOf?.(obstructWhiteFlag) === 0 && obstructWhiteList.indexOf(window.location.pathname.replace(publicUrlstatic, '')) !== -1

                let checkToken = '';
                if (isLoginForbid() && window.TEAMS?.checkToken) {
                    checkToken = `&checkToken=${window.TEAMS?.checkToken}`;
                }

                if (!isWhite) {
                    if (isMobileUA()) {
                        window.location.href = `${publicUrlstatic}/mobile/obstruct/login?oriService=${encodeURIComponent(window.location.href)}${checkToken}`;
                    } else {
                        window.location.href = `${publicUrlstatic}/sp/obstruct/login?oriService=${encodeURIComponent(window.location.href)}${checkToken}`;
                    }
                    return true;
                }
            }
            if (isMobileUA() && window.TEAMS?.remindUpdatePassword) {
                //记录拦截之前的地址
                localStorage.setItem('UPDATE_PASSWORD_REMIND_URL', window.location.href);
                if (!localStorage.getItem('UPDATE_PASSWORD_REMIND_LOADED')) {
                    window.location.href = `${publicUrlstatic}/mobile/obstruct/login`;
                    return true;
                }
            }
        }
        return false;
    }

    public reloadTEAMS() {
        let apiName = this.getTEAMSapi();
        this.request({
            type: 'POST',
            url: apiName,
            // params:ebParams,
            callback: (responseText: any) => {
                try {
                    const data = JSON.parse(responseText);
                    if (data?.code == -1) {
                        window?.weappLayout?.relogin();
                        return;
                    }
                    for (let key in data) {
                        window.TEAMS[key] = data[key];
                    }
                } catch (error) {

                }
            },
            async: true
        });
    }
    private afterFetchTeams(options: any) {
        const host = window.location.host;
        const { async, skipRequst, lastTEAMS, responseText } = options;
        if ((window.TEAMS?.actionMsg?.code == -1) || window.TEAMS.code == -1) {
            //埋点记录：eteamsid过期
            this.addAsyncMonitorTask({
                type: "passport_login_overtime",
                taskData: {
                    eteamsid: window.ETEAMSID,
                    teams: responseText || ''
                },
                des: 'eteamsid超时失效'
            })
            this.clearCookies();
            clearOneCookie('ETEAMSID');

            let isAppLoginPage = inMobileApp() && getQueryString("isLoginPage") === 'true'  //app中登录页

            //localhost环境屏蔽
            if (host.indexOf('localhost') === -1 && !isMobileUrl() && !inMobileApp() || isAppLoginPage) {
                if (window.weappTenantEnv?.loginPrivateUrl) {
                    //走主框架登录
                    window.showLayoutLogin = true;
                } else {
                    const logoutRequst = () => {
                        this.request({
                            type: 'GET',
                            url: `${publicUrlapi}/papi/app/baseserver/clearCookie?service=${encodeURIComponent(this.originServer)}`,
                            async: false,
                            callback: () => {
                                this.passportRedirect('logout');
                            }
                        })
                    }
                    if (inCasLogin()) {
                        this.logoutRecord(() => {
                            logoutRequst();
                        })
                    } else {
                        logoutRequst();
                    }
                }
            }
        } else {
            try {
                window.localStorage.setItem("E10_PASSPORT_ERROR_INFO", JSON.stringify(window.TEAMS));
            } catch (e) {
            }
            if (window.TEAMS?.status === 500 || window.TEAMS?.status === 504) {
                this.showSystemError({ errorType: `internet_error_${window.TEAMS?.status}` });
            } else if (window.TEAMS?.code === 500) {
                this.showSystemError({ errorType: 'service_error' });
            } else if (window.TEAMS?.displayModules?.indexOf('20230628|loadErr') > -1) {
                this.showSystemError({ errorType: 'loadErr' });
            } else if (window.TEAMS?.displayModules?.indexOf('20230628|lnError') > -1) {
                this.showSystemError({ errorType: 'lnError' });
            } else {
                let errorFlag = false;
                checkWeappUi(() => {
                    let msg = '';
                    if (window.TEAMS?.displayModules) {
                        window.TEAMS?.displayModules.forEach((it: any, index) => {
                            if (it.indexOf('license error') !== -1) {
                                errorFlag = true;
                                switch (it) {
                                    case 'license error,code is 0':
                                        msg = window.weappUtils.getLabel('250533', '授权信息错误');
                                        break;
                                    case 'license error,code is 3':
                                        msg = window.weappUtils.getLabel('250534', '未检测到授权');
                                        break;
                                    case 'license error,code is 4':
                                        msg = window.weappUtils.getLabel('250535', '授权已过期');
                                        break;
                                    case 'license error,code is 5':
                                        msg = window.weappUtils.getLabel('250536', '授权用户数超过系统允许的用户数');
                                        break;
                                    default:
                                        if (it.indexOf('license error,') === 0 && it.indexOf('license error,code is') !== 0) {
                                            msg = it.replace(/license error,/g, '');
                                        } else {
                                            msg = it;
                                        }
                                }
                            }
                        })
                    }
                    if (errorFlag) {
                        this.showSystemError({
                            showType: 'message',
                            content: msg
                        });
                    }
                });
            }
            //启用缓存
            // if (!withTicket) {
            if (window.TEAMS?.currentUser) {
                if (!this.hooksTool.teamsReady) {
                    this.hooksTool.getReadySuccessHook('TEAMS', window.TEAMS);
                    this.hooksTool.teamsReady = true;
                }
                //自定义登录页指定跳转系统地址处理
                if (window.TEAMS?.loginAccountInfo?.loginRedirectUrl) {
                    if (isMobileUA()) {
                        if (!sessionStorage.getItem("E10_loginRedirected")) {
                            if (inApp()) {

                            } else {
                                sessionStorage.setItem("E10_loginRedirected", "true")
                                const isExternalUrl = window.TEAMS?.loginAccountInfo?.loginRedirectUrl?.indexOf("http") === 0 && window.TEAMS?.loginAccountInfo?.loginRedirectUrl?.indexOf(window.location.host) === -1
                                if (isExternalUrl) {
                                    sessionStorage.removeItem("E10_loginRedirected")
                                }
                                window.location.href = window.TEAMS?.loginAccountInfo?.loginRedirectUrl;
                            }
                        }
                    } else {
                        if (this.loginWithTicket) {
                            window.location.href = window.TEAMS?.loginAccountInfo?.loginRedirectUrl;
                        }
                    }
                }

                //集成登录免登回到上次打开地址替换上一个登录人员id
                if (getQueryString('wea_link_keep_intunifyauth_client') === 'freepass') {
                    if (window.location.href.indexOf("${employeeId}") !== -1) {
                        const employeeId = window.TEAMS?.currentUser?.employeeId || window.TEAMS?.loginAccountInfo?.employeeId || '';
                        window.history.replaceState(null, null, window.location.href.replace("${employeeId}", employeeId));
                    }
                }

                try {
                    if (responseText) {
                        let lsTEAMSKey = 'E10_TEAMS_LOCAL';
                        window.localStorage.setItem(lsTEAMSKey, responseText);
                    }
                } catch (e) {
                    if (this.isLocalstorageExceedError(e?.name) && !window.locallsOversize) {
                        console.log('ls超容');
                        window.locallsOversize = true;
                        this.showClearPrompt();
                    }
                }

            } else {
                this.hooksTool.getReadyFailedHook('TEAMS', responseText)
            }



        }
        //创建ws
        if (
            window.location.host !== 'weapp.develop.cn' &&
            !this.useTempEmToken &&
            !this.websocketConnection &&
            !this.useTempToken && (
                inApp() && isMobileUA() ? (     //移动端
                    window.location.href?.indexOf('/mobile/uk/me') !== -1 && false //app暂时不建立长连接
                ) : (
                    !isThirdSSO() &&      //云桥不建立长连接
                    !isLoginTypeEb() &&   //云桥eb场景不建立
                    !isIframeOpen() &&
                    !this.checkWsBlackList()
                )
            )
        ) {
            try {
                this.runWebsocket();
            } catch (error) {
                console.info(error)
            }
        }
        if (!skipRequst) {
            if (async && lastTEAMS && !this.ebAsyncAuth) {
                let lastTeamsData = JSON.parse(lastTEAMS);
                const compares = ['currentUser.id', 'locale', 'displayModules', 'disableModules', 'empDisableModules']
                if (!isObstructPage()) {

                    try {

                        compares.forEach((it: string) => {
                            let keys = it.split('.');

                            let lsData = lastTeamsData;
                            let curData = window.TEAMS;

                            if (keys.length > 1) {
                                keys.forEach((key) => {
                                    if (lsData?.[key]) {
                                        lsData = lsData[key];
                                    }
                                    if (curData?.[key]) {
                                        curData = curData[key];
                                    }
                                })
                            } else {
                                lsData = lastTeamsData[keys[0]];
                                curData = window.TEAMS[keys[0]];

                                if ((keys[0] === 'disableModules' || keys[0] === 'empDisableModules')) {
                                    if (lsData && lsData.length > 0) {
                                        lsData = lsData.map((it) => {
                                            return {
                                                moduleId: it.moduleId,
                                                moduleStr: it.moduleStr
                                            }
                                        })
                                    }
                                    if (curData && curData.length > 0) {
                                        curData = curData.map((it) => {
                                            return {
                                                moduleId: it.moduleId,
                                                moduleStr: it.moduleStr
                                            }
                                        })
                                    }
                                }


                            }
                            if (JSON.stringify(lsData) !== JSON.stringify(curData)) {
                                if (window.location.host.indexOf('e-cology.com.cn') === -1) {
                                    // console.info('1--------' + lsData);
                                    // console.info('2--------' + curData);
                                    // alert('TEAMS对象发生变化');
                                    window.location.reload();
                                }
                            }
                        })
                    } catch (error) {

                    }
                }
            }
        }
        const client = getImClientType();
        //包含APP断网本地化情况
        if (skipRequst || responseText || (responseText === false && async)) {
            // ecode global
            this.getExtraTeamsData('GET', `/api/app/ecode/cache/globalData${client ? `?device=${client}` : ``}`, 'ecodeGlobalData', null, skipRequst);
            // 企业微信
            this.getExtraTeamsData('GET', '/api/bs/eb/hrm/dept/authAndConvertCount', 'wxAuthAndConver', null, skipRequst);
            // 公共组-系统配置页
            this.getExtraTeamsData('POST', '/api/bcw/systemConfig/getSystemConfig', 'systemConfig', {}, skipRequst);
            // 地图组件配置
            this.getExtraTeamsData('POST', '/api/bcw/map/selectTemplateByUserId', 'mapConfig', {}, skipRequst);
            // 用户配置
            // this.getExtraTeamsData('POST', '/api/bcw/userConfiguration/queryList', 'userDetailCardFormConfig', {});
            // 项目任务拆分
            this.getExtraTeamsData('GET', '/api/project/mainlines/queryAllConfig', 'projectConfig', null, skipRequst);
            // 日程拆分
            this.getExtraTeamsData('GET', '/api/bs/calendar/configuration/queryAllConfig', 'calendarConfig', null, skipRequst);
            //人员姓名
            this.getExtraTeamsData('GET', '/api/hrm/card/getCurrentSimpleEmployee', 'currentSimpleEmployee', null, skipRequst);
            // favicon
            this.getExtraTeamsData('GET', '/api/baseserver/layout/getTenantLogo', 'tenantLogo', null, skipRequst);
            // 用户习惯&全局配置
            // this.getExtraTeamsData('GET', '/api/bcw/base/configuration/getUserAndGlobalConfig', 'globalAndUserConfig');
        }

        this.extendTEAMS();

        let isLoginForbid = this.loginForbidRedirect();
        if (isLoginForbid){
            return;
        }

        if (skipRequst || responseText) {

            //此处指只对h5功能
            if (isMobileUrl()) {
                //license未授权
                if (!this.getModulePurchasedByUrl() && window.TEAMS.deploy && window.TEAMS.deploy !== 'public') {
                    window.location.href = `${publicUrlstatic}/mobile/uk/purchasedmoduletip`;
                    return;
                }

                //模块未安装
                if (!this.getModuleInstallByUrl()) {
                    window.location.href = `${publicUrlstatic}/mobile/uk/uninstallmoduletip`;
                    return
                }
                //应用管理禁用模块
                if (this.getModuleDisabledByUrl()) {
                    window.location.href = `${publicUrlstatic}/mobile/uk/disabledmoduletip`;
                    return
                }
            }

        }

        //单页模式跳转 -- 未安装
        if (window.location.pathname.replace(publicUrlstatic, '').indexOf('/sp/') === 0 && !this.getModuleInstallByUrl()) {
            window.location.href = `${publicUrlstatic}/info/uninstallmoduletip`;
            return
        }
        //单页模式跳转
        if (window.location.pathname.replace(publicUrlstatic, '').indexOf('/sp/') === 0 && !this.getModulePurchasedByUrl()) {
            window.location.href = `${publicUrlstatic}/info/purchasedmoduletip`;
            return
        }
        //单页模式跳转
        if (window.location.pathname.replace(publicUrlstatic, '').indexOf('/sp/') === 0 && this.getModuleDisabledByUrl()) {
            window.location.href = `${publicUrlstatic}/info/disabledmodule`;
            return
        }

        //通过单页方式访问的需判断是否锁定状态显示锁定
        if (window.TEAMS?.pageLockInfo?.lockStatus === "LOCK") {
            if (isPageInLockControl()) {
                this.showPcLock()
            }
        }

        //TEAMS对象兜底处理-locale国际化参数
        if (window.TEAMS?.locale && (!window.TEAMS?.locale?.lang || window.TEAMS?.locale?.lang === '""')) {
            window.TEAMS.locale.lang = getBrowserLangType()
        }

        //外部外部联系人紧急处理
        //自用系统外部联系人临时紧急控制
        if (isE10Self() && window.TEAMS?.currentTenant?.tenantKey === "t7akvdnf84" && window.TEAMS?.currentUser?.type === "external") {
            checkWeappUi(() => {
                let tit = window.weappUtils.getLabel('15976', '提示信息'),
                    msg = window.weappUtils.getLabel('252110', '当前登录的用户没有权限，请返回重新登录')
                if (inApp()) {
                    let _this = this;
                    window.weappUi?.MDialog?.prompt?.({
                        title: tit,
                        mask: true,
                        maskClosable: false,
                        message: msg,
                        onClose: function () { _this.logout() },
                        onOk: function () { _this.logout() },
                        prompt: false,
                    })
                } else {
                    // window.weappUi?.Dialog?.confirm?.({
                    //     content: msg,
                    //     onOk: function () { this.logout() },
                    //     onCancel: function () { this.logout() },
                    // });
                }
            });
        }


    }
    private getExtraTeamsData(type: string, api: string, hookName: string, params?: any, skipRequst?: boolean) {
        // let time = 0;
        // let loaded = false;
        let addToTEAMS = (res) => {
            if (res && res.data) {

                localStorage.setItem(`E10_EXTRADATA_${hookName}`, JSON.stringify(res));
                window[`E10_EXTRADATA_${hookName}`] = JSON.stringify(res);
                if (hookName == 'mapConfig') {
                    window.TEAMS.mapConfig = {};
                } else if (hookName == 'systemConfig') {
                    //暂时只缓存systemConfig
                    window.TEAMS.systemConfig = {};
                } else if (hookName == 'ecodeGlobalData') {
                    window.TEAMS.ecodeGlobalData = {};
                } else if (hookName == 'classificationData') {
                    window.TEAMS.classificationData = {};
                } else if (hookName == 'tenantLogo') {
                    window.TEAMS.tenantLogo = {};
                }
                // }
                if (hookName == 'globalAndUserConfig' || hookName == 'projectConfig' || hookName == 'calendarConfig') {
                    if (!window.TEAMS.userConfig) {
                        window.TEAMS.userConfig = {};
                    }
                    if (!window.TEAMS.globalConfig) {
                        window.TEAMS.globalConfig = {};
                    }
                    if (res.data.globalConfig) {
                        for (let key in res.data.globalConfig) {
                            if (Object.hasOwnProperty.call(res.data.globalConfig, key)) {
                                window.TEAMS.globalConfig[key] = res.data.globalConfig[key]
                            }
                        }
                    }
                    if (res.data.userConfig) {
                        for (let key in res.data.userConfig) {
                            if (Object.hasOwnProperty.call(res.data.userConfig, key)) {
                                window.TEAMS.userConfig[key] = res.data.userConfig[key]
                            }
                        }
                    }
                } else if (hookName == 'userDetailCardFormConfig') {
                    window.TEAMS.userDetailCardFormConfig = res.data
                } else if (hookName == 'currentSimpleEmployee') {
                    if (res.data?.username) {
                        if (window.TEAMS?.currentUser) {
                            window.TEAMS.currentUser.username = res.data.username;
                            window.TEAMS.currentUser.name = res.data.username;
                        }
                    }
                }
                else {
                    for (let key in res.data) {
                        if (Object.hasOwnProperty.call(res.data, key)) {
                            if (hookName == 'mapConfig') {
                                window.TEAMS.mapConfig[key] = res.data[key]
                            } else if (hookName == 'systemConfig') {
                                window.TEAMS.systemConfig[key] = res.data[key]
                            } else if (hookName == 'ecodeGlobalData') {
                                window.TEAMS.ecodeGlobalData[key] = res.data[key]
                            } else if (hookName == 'tenantLogo') {
                                window.TEAMS.tenantLogo[key] = res.data[key];
                                //TEAMS对象处理-favicon链接处理
                                if (window.TEAMS?.tenantLogo?.faviconUrl?.indexOf?.('/') === -1) {
                                    window.TEAMS.tenantLogo.faviconUrl = dealImageUrl(window.TEAMS.tenantLogo.faviconUrl)
                                }
                            } else if (hookName == 'classificationData') {
                                window.TEAMS.classificationData[key] = res.data[key]
                            } else {
                                window.TEAMS[key] = res.data[key]
                            }
                        }
                    }
                }
            }
        }
        //请求异常或超时
        let remedyFun = (needFaildCallback?: boolean) => {
            if (localStorage.getItem(`E10_EXTRADATA_${hookName}`)) {
                try {
                    const res = JSON.parse(localStorage.getItem(`E10_EXTRADATA_${hookName}`))
                    addToTEAMS(res);
                    this.hooksTool.getReadySuccessHook(hookName, res);
                } catch (error) {
                    this.hooksTool.getReadySuccessHook(hookName, {});
                }
                // loaded = true;
            } else if (needFaildCallback) {
                this.hooksTool.getReadyFailedHook(hookName, {});
            }
        }
        if (skipRequst && !inIframe() && window.opener[`E10_EXTRADATA_${hookName}`]) {
            const res = JSON.parse(window.opener[`E10_EXTRADATA_${hookName}`])
            addToTEAMS(res);
            this.hooksTool.getReadySuccessHook(hookName, res);
            return
        }
        if (this.useTempToken) {
            api = `${api}${api.indexOf('?') !== -1 ? '&' : '?'}ETEAMSID=${window.ETEAMSID}`;
        }
        let options: any = {
            type: type,
            url: `${publicUrlapi}${api}`,
            callback: (response: any) => {
                try {
                    let res = JSON.parse(response);
                    addToTEAMS(res);

                    if ((res.code && res.code == 200)) {
                        this.hooksTool.getReadySuccessHook(hookName, res);
                    } else {
                        this.hooksTool.getReadyFailedHook(hookName, res)
                    }
                } catch (e) {
                    remedyFun(true);
                }
            },
            async: true
        }
        if (params) {
            options.params = params;
        }
        this.request(options);

    }
    private extendTEAMS() {
        if (window.TEAMS && !window.TEAMS.actionMsg) {
            // if (!inApp() && !isMobileUA()) {  //TODO android语言切换问题处理 非app中用cookie中的langtype覆盖
            //覆盖多语言选项
            const langType = getCookie('langType');
            //以cookie优先
            if (langType && window.TEAMS?.locale?.lang) {
                window.TEAMS.locale.lang = langType;
            }
            if (getQueryString('wea_link_keep_langType') && window.TEAMS?.locale?.lang) {
                window.TEAMS.locale.lang = getQueryString('wea_link_keep_langType');
            }
            // }
            //处理页面ico问题
            // if (window.TEAMS?.tenantLogo?.faviconUrl) {
            //     let url = window.TEAMS.tenantLogo.faviconUrl;
            //     document.querySelector('link[rel="icon"]')?.setAttribute('href', url);
            // }

            //模块付费
            window.TEAMS.isPayModule = (module: string) => {
                return window.TEAMS.currentTenant && window.TEAMS.currentTenant.payModuleName != null && window.TEAMS.currentTenant.payModuleName?.indexOf(module) !== -1;
            }
            //模块管理员
            window.TEAMS.isModuleAdmin = (module: string) => {
                return window.TEAMS.currentUser && window.TEAMS.currentUser.modules != null && window.TEAMS.currentUser.modules?.indexOf(module) !== -1;
            }
            //应用使用范围无人员权限模块
            window.TEAMS.isDisabledModule = (module: string, customReturnValue?: string) => {//customReturnValue：是否返回对应的禁用类型（团队，个人）
                let flag = false;
                let disabledType = '';
                if (module === 'portal') {
                    module = 'gateway';
                }
                if (window.TEAMS.disableModules?.length > 0) {
                    window.TEAMS.disableModules.forEach((it: any) => {
                        if (it.moduleStr === module) {
                            if (it.moduleStr === 'gateway' && it.moduleId === '-6') {
                                flag = true;
                            }
                            if (module === 'form' && it.moduleId === "11") {
                                flag = true;
                            }
                            if (module === 'workflow' && it.moduleId === "2") {
                                flag = true;
                            }
                            if (module != "form" && it.moduleStr != "workflow") {
                                flag = true;
                            }
                        }
                    })
                    if (flag) {
                        disabledType = 'TEAM'
                    }
                }
                //个人禁用模块
                if (window.TEAMS.empDisableModules?.length > 0) {
                    window.TEAMS.empDisableModules.forEach((it: any) => {
                        if (it.moduleStr === module) {
                            if (it.moduleStr === 'gateway' && it.moduleId === '-6') {
                                flag = true;
                            }
                            if (module === 'form' && it.moduleId === "11") {
                                flag = true;
                            }
                            if (module === 'workflow' && it.moduleId === "2") {
                                flag = true;
                            }
                            if (module != "form" && it.moduleStr != "workflow") {
                                flag = true;
                            }
                        }
                    })
                    if (flag) {//应用禁用类型-个人，团队和个人都禁用时优先返回个人禁用标志
                        disabledType = 'PERSONAL'
                    }
                }
                if (customReturnValue === 'RETURN_DISABLED_TYPE') {//自定义返回是团队禁用、个人禁用标志
                    return { disabledType }
                }

                return flag;
            }

            //展示应用
            window.TEAMS.isDisplayModule = (module: string) => {
                return !!(window.TEAMS.displayModules && window.TEAMS.displayModules.length > 0 && window.TEAMS.displayModules.indexOf(module) !== -1);
            }
            //已购买授权应用--变更为”未启用“
            window.TEAMS.isPurchasedModule = (module: string) => {
                const whiteList = ['teamSharing', 'workTrends'];
                const { licenseModules = [], displayModules = [], installModules = [] } = window.TEAMS;
                if (whiteList.indexOf(module) !== -1) {
                    return true;
                }
                if (licenseModules && licenseModules.indexOf(module) === -1) {
                    return false;
                }
                // 暂不判断未安装，默认全部安装
                if (licenseModules.indexOf(module) !== -1 && displayModules.indexOf(module) === -1 && (!window.TEAMS.installEnable || installModules.indexOf(module) !== -1) && !window.TEAMS.isDisabledModule(module)) {
                    // if (licenseModules.indexOf(module) !== -1 && displayModules.indexOf(module) === -1 && !window.TEAMS.isDisabledModule(module)) {
                    return false;
                }

                return true;
            }
            //已安装应用
            window.TEAMS.isInstalledModule = (module: string) => {
                // 暂不判断未安装
                // return true
                if ((window.TEAMS.deploy && window.TEAMS.deploy === 'public') || !window.TEAMS.installEnable ) {
                    return true;
                }
                return window.TEAMS?.installModules?.indexOf(module) !== -1;
            }

            window.TEAMS.getModulePurchasedByUrl = (url: string) => {
                return this.getModulePurchasedByUrl();
            }
            window.TEAMS.getModuleInstallByUrl = (url: string) => {
                return this.getModuleInstallByUrl();
            }
            // window.TEAMS.getModuleDisabledByUrl = (url: string) => {
            //     return this.getModuleDisabledByUrl();
            window.TEAMS.getModuleDisabledByUrl = (customReturnValue?: string) => {
                return this.getModuleDisabledByUrl(customReturnValue);
            }
            //获取当前module
            window.TEAMS.getModuleNameByUrl = (path?: string) => {
                return this.getCurrentModuleByMap('displayModule', path);
            }

            //根据url判断模块禁用与license付费（统一返回）
            window.TEAMS.getModuleStatusByUrl = (url: string) => {
                return this.getModuleStatusByUrl(url);
            }

            window.TEAMS.updateCache = (field: string, value: any) => {
                return this.updateCache(field, value);
            }

            window.TEAMS.getPathByModule = (moduleId: string) => {
                return this.getPathByModule(moduleId);
            }

            const pathname = window.location.pathname.replace(publicUrlstatic, ''),
                spaceTag = '/eworkspace_';

            if (pathname.indexOf(spaceTag) !== -1) {
                let userId = pathname.split(spaceTag)[1].split("/")[0];
                if (userId !== window.TEAMS.currentUser.id) {
                    //为下属工作空间
                    window.TEAMS.eworkspace = {
                        userId: userId
                    }
                }
            }

            //下属空间中不使用ecode样式
            //预览模式不启用特色主题
            //特色主题下可返回标准主题
            let forceTheme = getQueryString('wea_link_keep_standardTheme');
            let isPreview = null;
            try {
                isPreview = window.parent?.previewData || window.parent?.previewThemeData;
            } catch (error) {

            }
            if (window.TEAMS.eworkspace || isPreview || (forceTheme && forceTheme == '1')) {
                if (window.TEAMS.theme) {
                    delete window.TEAMS.theme.appId;
                    delete window.TEAMS.theme.ecode;
                    delete window.TEAMS.theme.ecodeStr;
                }
            }
        }
    }
    private queryEteamsidByToken() {
        let token = getQueryString('wea_link_keep_tempOtherToken');
        this.request({
            type: 'POST',
            url: this.originServer + `${publicUrlapi}/api/baseserver/login/checkTempOtherToken`,
            async: false,//同步请求
            params: {
                tempOtherToken: token
            },
            callback: (responseText: any) => {

                try {
                    let res = JSON.parse(responseText);
                    if (res.code == 200 && res.data) {
                        window.ETEAMSID = res.data;
                        // sessionStorage.setItem('E10_ETEAMSID', window.ETEAMSID);
                    }
                } catch (e) {
                }
            }
        })
    }
    // E9单点E10，非通用，仅EM场景
    private queryEteamsidByEmToken() {
        const token = getQueryString('wea_link_keep_tempEmAuthToken');
        const corpid = getQueryString('em_corpid')
        this.request({
            type: 'POST',
            url: this.originServer + `${publicUrlapi}/papi/em/base/emSSOLogin`,
            async: false,//同步请求
            params: {
                auth_code: token,
                corpid: corpid
            },
            callback: (responseText: any) => {
                // 测试
                window.emSSOLoginResText = responseText;
                try {
                    const res = JSON.parse(responseText);
                    if (res.eteamsId) {
                        const eteamsId = res.eteamsId;
                        window.ETEAMSID = eteamsId;
                        setCookie('ETEAMSID', eteamsId);
                    }
                } catch (e) {
                    console.info(e);
                }
            }
        })
    }
    private checkEteamsId(noLogout = false, callback?: any, onNetError?: any) {
        window.passport_record.eteamsid_check_start = Date.now();
        !isLoginForbid() && this.request({
            type: 'POST',
            url: `${publicUrlapi}/papi/app/baseserver/info/getInfo`,
            callback: (responseText: any, status) => {
                // console.info(status);
                try {
                    const showSysError = () => {
                        checkWeappUi(() => {
                            const isNetError = status === 0;
                            window.weappUi.Dialog.confirm({
                                content: isNetError ?
                                    window.weappUtils.getLabel('266528', '系统检测到可能存在网络异常，如无法正常访问请检查您的网络环境后刷新尝试') :
                                    window.weappUtils.getLabel('257753', '系统出错了，请稍后再试'),
                                footer: [
                                    React.createElement(window.weappUi.Button, { onClick: () => window.location.reload() }, window.weappUtils.getLabel('17768', '刷新')),
                                    React.createElement(window.weappUi.Button, { type: "primary", onClick: () => this.logout() }, window.weappUtils.getLabel('171669', '返回登录界面'))
                                ],
                            });
                        });
                    }

                    if (status !== 200) {
                        this.getInfoError = true;
                        showSysError();
                        console.info(String(status), responseText)
                        return;
                    }

                    const data = JSON.parse(responseText);

                    window.passport_record.eteamsid_check_end = Date.now();
                    const cks = data?.data || {};

                    if (cks['ACCESS_ETEAMSID']) {
                        window.ETEAMSID = cks['ACCESS_ETEAMSID'];
                        // if (temp) {
                        //     alert('通过企微认证获取的eteamsid：' + window.ETEAMSID)
                        // } else {
                        //     alert('非企微同步认证获取或已经认证过来自缓存的eteamsid：' + window.ETEAMSID)
                        // }
                    } else if (!noLogout) {
                        if (getQueryString('wea_link_keep_nsAuth')) {
                            if (this.frameToken) {
                                checkWeappUi(() => {
                                    window.weappUi.Dialog.message({
                                        content: 'invalid token'
                                    });
                                });
                            }
                        } else {
                            if (data?.code === '20211217') {
                                checkWeappUi(() => {
                                    window.weappUi.Dialog.confirm({
                                        content: data.message,
                                        footer: React.createElement(window.weappUi.Button, { type: "primary", onClick: () => this.logout() }, window.weappUtils.getLabel('171669', '返回登录界面')),
                                    });
                                });
                            } else if (data?.code !== 200) {
                                this.getInfoError = true;
                                showSysError();
                                console.info(String(status), responseText)
                                return;
                            } else {
                                if (
                                  !this.ebAsyncAuth &&
                                  !isThirdLogin() &&
                                  !(window.weappTenantEnv?.intunifyauthOpen === 'true' && getQueryString('wea_link_keep_intunifyauth_client') !== 'freepass')
                                  // (!inMobileApp() || (inMobileApp() && getQueryString("isLoginPage") === "true"))
                                ) {
                                    this.logout();
                                }
                                return;
                            }
                        }

                    }

                    cks['langType'] && localStorage.setItem('langType', cks['langType']);
                    if (cks['caslogouturl']) {
                        sessionStorage.setItem('E10_CASLOGOUTURL', cks['caslogouturl']);
                    } else {
                        sessionStorage.removeItem('E10_CASLOGOUTURL');
                    }
                    if (cks['CASTGC']) {
                        sessionStorage.setItem('E10_CASTGC', cks['CASTGC']);
                    } else {
                        sessionStorage.removeItem('E10_CASTGC');
                    }
                    if (getCookie('E10_moduleSource')) {
                        window.thirdLoginModuleSource = getCookie('E10_moduleSource');
                    }
                } catch (error) {

                }
                callback && callback();
            }

        })

    }
    private loginTicket(ticket: any, href?: string, fromWeappBrowser?: boolean, fromNewTeam?: boolean) {
        if (!href) {
            href = window.location.href;
        }
        let ticketApi = this.baseServer + '/layout?ticket=' + ticket + '&service=' + encodeURIComponent(href);
        if (fromWeappBrowser) {
            ticketApi = `${publicUrlapi}/papi/baseserver/eteamsId/checkTicket`;
        }
        this.requestApiNames.push(ticketApi);
        const originTicketRequst = () => {
            this.request({
                type: 'POST',
                url: ticketApi,
                callback: (responseText: any) => {
                    this.checkEteamsId();
                }
            })
        }
        if (fromWeappBrowser) {
            const weappBrowerParams = {
                service: encodeURIComponent(href),
                ticket: ticket
            }
            this.request({
                type: 'POST',
                url: ticketApi,
                params: weappBrowerParams,
                callback: (responseText: any) => {
                    try {
                        const data = JSON.parse(responseText);
                        if (data.code === 2000) {
                            window.location.replace(`${publicUrlstatic}/sp/obstruct/onlinerebuild?onlineTicket=${ticket}&service=${service}&wea_link_keep_ecode_noreload=1`)
                        } else {
                            originTicketRequst()
                        }
                    } catch (error) {
                        originTicketRequst()
                    }
                }
            })
            if (this.getInfoError) {
                return;
            }
        } else {
            let clearCookieApi = `${publicUrlapi}/papi/app/baseserver/clearCookie?service=${encodeURIComponent(this.originServer)}`;
            if (fromNewTeam) {
                clearCookieApi = `${publicUrlapi}/papi/app/baseserver/clearCookieByName?cookieNames=ETEAMSID,WECHAT_ETEAMSID&service=${encodeURIComponent(window.location.href)}`
            }
            if (getCookie('E10_moduleSource')) {
                window.thirdLoginModuleSource = getCookie('E10_moduleSource');
                // if (window.location.pathname !== '/') {

                // }
            }
            this.request({
                type: 'GET',
                url: clearCookieApi,
                callback: () => {
                    clearOneCookie('ETEAMSID');//兜底
                    clearOneCookie('E10_moduleSource');
                    originTicketRequst()
                }
            })
        }
        //intunifyauthTransferUrl参数存在，且有ticket情况，等ticket校验完成再作跳转
        this.intunifyauthUrlTransfer(true);

        if (!window.ETEAMSID) {
            this.addAsyncMonitorTask({
                type: "passport_login_eteamsIdGetFaild",
                taskData: {
                    ticket: ticket
                },
                des: 'eteamsid获取异常'
            })
        }
        window.fromLoginPage = true;
        this.loginWithTicket = true;
        this.fetchTEAMS(true);
    }
    private getETEAMSID() {
        //兼容APP本地化，单独放开APP cookie
        let ck: any = document.cookie.match(/(^| )ETEAMSID=([^;]*)(;|$)/);
        if (ck) {
            return unescape(ck[2])
        } else {
            return undefined
        }
    }
    private login() {
        let host = window.location.hostname;

        //如果页面有ticket即为从账号登录来, 则不对比TEAMS，直接登录并获取新TEAMS
        let href = window.location.href;
        let ticket = getQueryString('ticket');
        //不清除eteamsid
        this.clearCookies();
        //APP本地化兼容，从cookie拿一次
        // if (inApp()) {
        //     window.ETEAMSID = this.getETEAMSID();
        // }
        // let ua = window.navigator.userAgent;

        //e10间单点
        if (getQueryString('wea_link_keep_tempOtherToken')) {
            this.useTempToken = true;
            this.queryEteamsidByToken();
        }
        if (getQueryString('wea_link_keep_tempEmAuthToken')) {
            this.useTempEmToken = true;
            //E9-EM单点E10认证，非通用，仅Em消息，token一次性消费，不同于统一代办场景
            if (this.useTempEmToken) {
                this.queryEteamsidByEmToken();
            }
        }

        if (getQueryString('wea_link_keep_ebAsyncAuth') == '1' || getQueryString('wea_link_keep_specialAuthcheck') == '1') {
            this.ebAsyncAuth = true;
        }
        if (ticket) {
            let fromWeappBrowser = !!(getQueryString('fromWeappBrowser') === '1');
            let fromNewTeam = !!(getQueryString('changeTenant') === '1');
            let detachTk = getQueryString("detachTk")
            let ticketIdx = href.indexOf('ticket=');
            href = href.substr(0, ticketIdx - 1);
            if (detachTk) {
                href = `${href}${href.indexOf("?") === -1 ? '?' : '&'}wea_link_keep_detachTk=${detachTk}`
            }
            window.history.replaceState(null, null, href);
            window.sessionStorage.removeItem('E10_PORTALINTRO_LOADED');
            // 重新获取eteamsid
            this.loginTicket(ticket, href, fromWeappBrowser, fromNewTeam);
        } else {
            //
            if (window.ETEAMSID) {
                // 验证ETEAMSID是否匹配
                this.fetchTEAMS();
            } else {

                //从登录拦截过来
                if (isYunTeams()) {
                    if (getQueryString('checkToken')) {
                        this.checkLoginForbid();
                        if (isLoginForbid()) {
                            return;
                        }
                    }
                }

                //这里有两种情况，1.前端cookie有（云桥或集成登录），2.真的没有
                // 从父页面打开的情况
                try {
                    // if (window.opener?.ETEAMSID && !window.fromLoginPage) {
                    //     window.ETEAMSID = window.opener?.ETEAMSID
                    // } else
                    if (inIframe() && window.parent?.ETEAMSID) {
                        window.ETEAMSID = window.parent?.ETEAMSID
                        // alert('从父窗口获取eteamsid')
                    } else {
                        this.checkEteamsId();//尝试从cookie中拿一次
                        // alert('已有有效eteamsid缓存的情况进入，不重新认证')
                    }
                } catch (error) {
                    this.checkEteamsId();//尝试从cookie中拿一次
                }

                if (this.logoutTimes > 0 || this.getInfoError) {
                    return;
                }
                if (window.ETEAMSID) {
                    this.hooksTool.getReadySuccessHook('authChecked', {
                        type: 'unknow',
                        data: { eteamsid: window.ETEAMSID }
                    });
                    this.fetchTEAMS();
                } else {
                    //南山政府iframe通信认证，可作为通用场景
                    if (getQueryString('wea_link_keep_nsAuth') === '1') {
                        this.getTokenFromPostMsg();
                        const root = document.getElementById('root');
                        if (root) {
                            root.style.display = 'none';
                        }
                        window.onerror = function (message) {
                            console.error('An error occurred:', message);
                            return true;
                        };
                        return;
                    }

                    if (isThirdLogin()) {
                        let ebAsync = getQueryString('wea_link_keep_async');
                        if (ebAsync && ebAsync == '1') {
                            this.disPatchebAuthCheck();
                            // if (!this.ebAsyncAuth) {
                            //     this.checkEteamsId(false, function () {
                            //         // window.passport_record.passport_checkEteamsid_request_end = Date.now();
                            //     }, true);
                            //     this.fetchTEAMS();//通过这个接口判断云桥登录状态
                            // }
                        } else {
                            this.thirdLogin();
                        }
                    } else {
                        if (host.indexOf('localhost') == -1) {

                            if (window.weappTenantEnv?.loginPrivateUrl) {
                                //走主框架登录
                                window.showLayoutLogin = true;
                            } else {
                                if (getQueryString('wea_link_keep_intunifyauth_client') === 'freepass') {
                                    window.location.replace(`${this.passportServer}${publicUrlstatic}/login?service=${window.location.href}}`)
                                }
                                if (!inMobileApp()) {
                                    this.passportRedirect('login', window.location.href);
                                }
                            }
                        }
                    }
                }


            }
        }

    }
    private useTempToken: boolean = false;
    private useTempEmToken: boolean = false;
    private ebAsyncAuth: boolean = false;
    private logoutRecord(callback?: any) {
        this.request({
            type: 'GET',
            url: `${publicUrlapi}/api/basicserver/logs/addLoginOutLog`,
            async: false,
            callback: () => { callback && callback() }
        })
    }
    private passportRedirect(type = 'logout', href?: any) {
        let redirectUrl: any = href ? href : this.originServer + publicUrlapi;
        const CASTGC = sessionStorage.getItem('E10_CASTGC');
        if (CASTGC) {
            // alert(CASTGC);
            this.request({
                type: 'GET',
                url: `${publicUrlapi}/papi/app/baseserver/clearCookieByName?cookieNames=CASTGC&service=${encodeURIComponent(window.location.href)}`,
                async: false,
                callback: () => {
                    clearOneCookie('CASTGC')//兜底
                    sessionStorage.removeItem('E10_CASTGC')

                    let logoutUrl = `${this.originServer}${publicUrlstatic}/sp/integration/authLogoutNotify/freepass?tk=${encodeURIComponent(window.btoa(window.TEAMS?.currentTenant?.tenantKey))}&service=${encodeURIComponent(`${this.passportServer}/login`)}&castgc=${CASTGC}${inCasLogin() ? `&caslogouturl=${encodeURIComponent(sessionStorage.getItem('E10_CASLOGOUTURL'))}` : ``}`;

                    const intunifyauthTransferUrl = getQueryString("intunifyauthTransferUrl")
                    if (intunifyauthTransferUrl) {
                        logoutUrl = window.location.href;
                    }
                    window.location.href = `${this.passportServer}${publicUrlapi}/papi/passport/logout?service=${encodeURIComponent(logoutUrl)}`
                }
            })

        } else if (inCasLogin()) {
            // if (inCasLogin()) {
            this.request({
                type: 'GET',
                url: `${publicUrlapi}/papi/app/basicserver/clearCookieByName?cookieNames=CASTGC&service=${encodeURIComponent(window.location.href)}`,
                async: false,
                callback: () => {
                    redirectUrl = sessionStorage.getItem('E10_CASLOGOUTURL');
                    redirectUrl = redirectUrl.toString().replace(/"/g, '');
                    sessionStorage.removeItem('E10_CASLOGOUTURL');
                    clearOneCookie('caslogouturl');
                    clearOneCookie('CASTGC')//兜底
                    sessionStorage.removeItem('E10_CASTGC')
                    // window.location.href = redirectUrl;
                    window.location.replace(`${this.passportServer}${publicUrlapi}/papi/passport/logout?service=${encodeURIComponent(redirectUrl)}`);
                }
            })


        } else {
            clearOneCookie('CASTGC')//兜底
            sessionStorage.removeItem('E10_CASTGC')
            window.sessionStorage.removeItem('E10_PORTALINTRO_LOADED');
            if (type === 'login') {
                if (!inMobileApp()) {
                    if (getQueryString('wea_link_keep_intunifyauth_client') === 'freepass') {
                        window.location.replace(`${this.passportServer}${publicUrlstatic}/login`)
                    }
                    if (this.sysLogoutUrl){
                        window.location.replace(`${this.sysLogoutUrl}?service=${encodeURIComponent(href)}`);
                    } else if (window.weappTenantEnv?.intunifyauthOpen === 'true' && getQueryString('wea_link_keep_intunifyauth_client') !== 'freepass') {
                        const intunifyauthUrl = window.weappTenantEnv.intunifyauthUrl || '';
                        window.location.replace(`${window.weappTenantEnv.weappUrl}${intunifyauthUrl}${intunifyauthUrl.indexOf('?') !== -1 ? '&' : '?'}oaAddress=${encodeURIComponent(href)}&oaUrl=${encodeURIComponent(window.weappTenantEnv.weappUrl)}&passportUrl=${encodeURIComponent(window.weappTenantEnv.passportUrl)}`);
                    } else {
                        window.location.replace(`${this.passportServer}${publicUrlstatic}/login?service=${encodeURIComponent(href)}`);
                    }
                }
            } else {

                const employeeId = window.TEAMS?.currentUser?.employeeId || window.TEAMS?.loginAccountInfo?.employeeId || '';
                const loginType = window.TEAMS?.loginAccountInfo?.loginType;

                if (window.weappTenantEnv?.intunifyauthOpen === 'true' && getQueryString('wea_link_keep_intunifyauth_client') !== 'freepass' && !this.sysLogoutUrl) {
                    //跳转集成登录地址
                    const intunifyauthUrl = window.weappTenantEnv.intunifyauthUrl || '';
                    logoutUrl = `${window.weappTenantEnv.weappUrl}${intunifyauthUrl}${intunifyauthUrl.indexOf('?') !== -1 ? '&' : '?'}oaAddress=${encodeURIComponent(href)}&oaUrl=${encodeURIComponent(window.weappTenantEnv.weappUrl)}&passportUrl=${encodeURIComponent(window.weappTenantEnv.passportUrl)}`;
                    window.location.replace(`${this.passportServer}${publicUrlapi}/papi/passport/logout?service=${encodeURIComponent(logoutUrl)}`);
                } else if (window.TEAMS?.loginAccountInfo?.passportCusLoginPath) {
                    let passportDomain = window.weappTenantEnv.passportUrl;
                    if (window.TEAMS?.loginAccountInfo?.passportCusLoginDomain) {
                        passportDomain = window.TEAMS?.loginAccountInfo?.passportCusLoginDomain;
                    }
                    //自定义登录页跳转处理
                    window.location.replace(`${this.passportServer}${publicUrlapi}/papi/passport/logout?service=${encodeURIComponent(passportDomain + publicUrlstatic + window.TEAMS.loginAccountInfo.passportCusLoginPath + '?service=' + encodeURIComponent(redirectUrl))}${employeeId ? `&employeeId=${employeeId}` : ``}${loginType ? `&loginType=${loginType}` : ``}`);
                } else {
                    let returnUrl = `${this.originServer}${publicUrlstatic}${window.location.search}`;

                    //对主地址访问二级路径带/的情况需要保持
                    if (window.location.pathname === `${publicUrlstatic}/`) {
                        returnUrl = `${this.originServer}${publicUrlstatic}/${window.location.search}`;
                    }

                    const isIntunifyFreePass = getQueryString('wea_link_keep_loginType') === 'intunifyauth';

                    //绕过集成登录情况并且从登录过来
                    if (isIntunifyFreePass && (window.fromLoginPage === true || this.loginWithTicket === true)) {
                        returnUrl = window.location.href.replace(`${window.TEAMS.currentUser.employeeId}`, '${employeeId}')
                    } else {
                        const intunifyauthTransferUrl = getQueryString("intunifyauthTransferUrl")
                        if (    //需要返回上次退出登陆前地址的
                            window.location.pathname.indexOf(`${publicUrlstatic}/info`) === 0 || //后台管理中心地址
                            isSpPage() ||  //单页情况模式
                            window.location.pathname.indexOf(`/community/index`) !== -1 || intunifyauthTransferUrl//我的社区
                        ) {
                            returnUrl = window.location.href

                            //登录拦截页情况
                            if (window.location.href.indexOf('/obstruct/') !== -1) {
                                returnUrl = getQueryString("oriService") ? decodeURIComponent(getQueryString("oriService")) : `${this.originServer}${publicUrlstatic}${window.location.search}`;
                            }
                        }
                    }

                    let loginpath = `${this.passportServer}${publicUrlstatic}/login?service=${encodeURIComponent(returnUrl)}`;
                    if (this.sysLogoutUrl){
                        loginpath = `${this.sysLogoutUrl}?service=${encodeURIComponent(returnUrl)}`;
                    }

                    if (loginType && loginType === "detach_manager") {
                        if (window.sessionStorage.getItem(`E10_PASSPORT_ADMINLOGIN_ADDR`)) {
                            loginpath = window.sessionStorage.getItem(`E10_PASSPORT_ADMINLOGIN_ADDR`)
                        } else {
                            let detachTk = getQueryString("wea_link_keep_detachTk");
                            loginpath = `${this.passportServer}${publicUrlstatic}/adminlogin${detachTk ? `?detachTk=${detachTk}` : ''}`;
                        }
                    }
                    if (getQueryString('registerSourceUrl')) {
                        let siteParams = [
                            `moduleSource=${getQueryString('moduleSource') || ''}`,
                            `registerSourceUrl=${getQueryString('registerSourceUrl') || ''}`,
                            `registerSource=${getQueryString('registerSource') || ''}`,
                            `registerLang=${getQueryString('registerLang') || ''}`
                        ]
                        loginpath += `${loginpath.indexOf('?') !== -1 ? '&' : '?'}${siteParams.join('&')}`;
                    }

                    window.location.replace(`${this.passportServer}${publicUrlapi}/papi/passport/logout?service=${encodeURIComponent(loginpath)}${employeeId ? `&employeeId=${employeeId}` : ``}${loginType ? `&loginType=${loginType}` : ``}`);
                }
            }

        }
    }
    //退出登录
    public logout(callback?: any) {
        // if (localStorage.getItem('passport_logouttest')) {
        // if (getQueryString('wea_link_keep_tempEmAuthToken') || localStorage.getItem('emtoken_test')) {
        //     return;
        // }
        window.ecode_passportBeforeLogout?.();

        try {
            this.request({
                type: 'POST',
                url: `${publicUrlapi}/papi/basiconline/offline/exitConn`,
                // async: true,
                params: {
                    "userId": window.TEAMS?.currentUser?.userId,
                    "eteamsId": window.ETEAMSID,
                    "label": 'exit_login',
                    "channelId": window['E10_WS_channelId'] || null
                },
                callback: () => {
                    this.logoutFunc()
                }
            });
        } catch (error) {
            this.logoutFunc()
        }

    }
    public logoutFunc() {
        if (this.logoutTimes > 0) {
            return;
        }
        window.forbidReloginDialog = true;
        this.logoutTimes += 1;
        this.websocketConnection && this.websocketConnection.close();
        if (window.TEAMS?.currentUser && window.TEAMS?.currentTenant) {
            let empId = window.TEAMS.currentUser.id,
                tenantKey = window.TEAMS.currentTenant.tenantKey;
            let refreshEmployeeApi = this.originServer + `${publicUrlapi}/papi/app/baseserver/refreshEmployee?empId=` + empId + '&tenantKey=' + tenantKey;
            this.requestApiNames.push(refreshEmployeeApi);
            this.request({
                type: 'GET',
                url: refreshEmployeeApi,
                async: false
            });
        }

        //集成登录cookie清理
        // clearOneCookie('CASTGC');
        // h5门户默认首页退出标记
        window.sessionStorage.removeItem('portalConfigLoaded');
        window.localStorage.removeItem('WEAPP_LAYOUT_DOC_DETAILSPOP');

        //首次登录跳转标记清理
        sessionStorage.removeItem("E10_loginRedirected")

        const logoutRequst = () => {

            this.request({
                type: 'GET',
                url: `${publicUrlapi}/papi/baseserver/clearEteamsId`,
                async: false,
                callback: () => {
                    this.request({
                        type: 'GET',
                        url: `${publicUrlapi}/papi/app/baseserver/clearCookie?service=${encodeURIComponent(this.originServer)}`,
                        async: false,
                        callback: () => {
                            this.clearCookies();
                            clearOneCookie('ETEAMSID');
                            // if (window.weappTenantEnv?.loginPrivateUrl && !isMobileUA()) {
                            //     //走主框架登录 ？？ 如果确保退出登录
                            //     this.request({
                            //         type: 'GET',
                            //         url: this.passportServer + '/papi/passport/logout',
                            //         async: false,
                            //         callback: function () {

                            //             if (window.weappLayout?.ee) {
                            //                 window.showLayoutLogin = true;
                            //                 window.history.replaceState(null, '', '/');
                            //                 // TEAMS = null;
                            //                 window.weappLayout.ee.emit('layout.layoutloginShown', true);
                            //             } else {
                            //                 window.location.replace(window.weappTenantEnv.weappUrl);
                            //             }
                            //             if (callback) {
                            //                 callback();
                            //             }
                            //         }
                            //     });
                            // } else {
                            if (this.getInfoError) {
                                this.passportRedirect('logout');
                            } else {
                                this.request({
                                    type: 'POST',
                                    url: `${publicUrlapi}/papi/app/baseserver/info/getInfo`,
                                    callback: (responseText: any, status) => {
                                        try {
                                            const data = JSON.parse(responseText);
                                            const cks = data.data || {};
                                            if (cks['CASTGC']) {
                                                sessionStorage.setItem('E10_CASTGC', cks['CASTGC']);
                                            } else {
                                                sessionStorage.removeItem('E10_CASTGC');
                                            }
                                            this.passportRedirect('logout');
                                        } catch (e) {
                                        }
                                    }
                                })
                            }
                            // }
                        }
                    })

                }
            })
        }
        if (inCasLogin()) {
            this.logoutRecord(() => {
                logoutRequst();
            })
        } else {
            logoutRequst();
        }
    }
    public clearCookies(keepEteamsId = false) {
        // clearOneCookie("ETEAMSID");
        // clearOneCookie("WECHAT_ETEAMSID");
        // if (!keepEteamsId) {
        //     sessionStorage.removeItem('E10_ETEAMSID');
        // }
        //删除H5拦截页密码提醒弹框标记
        localStorage.removeItem('UPDATE_PASSWORD_REMIND_LOADED');
        localStorage.removeItem('UPDATE_PASSWORD_REMIND_URL');

    }

    //主框架直接登录
    public layoutLogin(ticket: any, callback: any) {
        this.loginTicket(ticket);
        callback();
    }
    //从url获取当前module
    public getCurrentModuleByMap(mapType: string, path?: any) {
        let routeMap,
            currentModule = '';
        if (!path) {
            path = window.location.pathname.replace(publicUrlstatic, '');
        }
        path = path.toLowerCase();
        //sp单页
        if (path.indexOf('/sp/') === 0) {
            path = path.replace('/sp', '');
        }
        if (mapType == 'standardModules') {
            routeMap = moduleRouteMap; //仅cover url能匹配获取的部分
        } else {
            routeMap = disPlayModuleRouteMap;
        }
        //pc由于受到“记录上次访问地址”影响，调用主框架时在主框架获取当前模块
        for (var i = 0; i < routeMap.length; i++) {
            var route = routeMap[i].toLowerCase().split('::'),
                oriRoute = routeMap[i].split('::'),
                moduleId = oriRoute[0],//moduleId不分大小写
                pcPath = route[1],
                mPath = route[2];
            if (isMobileUrl()) {
                if (path.indexOf(mPath) === 0) {
                    currentModule = moduleId;
                    break;
                }
            } else {
                if (path.indexOf(pcPath) === 0) {
                    currentModule = moduleId;
                    break;
                }
            }
        }
        return currentModule;
    }
    public getPathByModule(module: string) {
        let routeMap = moduleRouteMap;
        let path = []
        for (var i = 0; i < routeMap.length; i++) {
            var route = routeMap[i].toLowerCase().split('::'),
                oriRoute = routeMap[i].split('::'),
                moduleId = oriRoute[0],//moduleId不分大小写
                pcPath = route[1],
                mPath = route[2];
            if (module === moduleId) {
                path.push(pcPath);
                path.push(mPath);
            }
        }
        return path;
    }
    //未购买的模块判断
    public getModulePurchasedByUrl() {
        let flag = true;//未知模块默认授权通过
        let currentModule = this.getCurrentModuleByMap('displayModules');

        //能获取到具体module且当前module未购买
        if (currentModule && !window.TEAMS?.isPurchasedModule(currentModule)) {
            flag = false
        }
        // im模块im和emmsg满足一个即展示
        if (currentModule === 'im' && (window.TEAMS?.isPurchasedModule?.('im') || window.TEAMS?.isPurchasedModule?.('emmsg'))) {
            flag = true;
        }
        //以下地址放行
        if (this.pathMapMathed(licenseWhiteMap)) {
            return true;
        }
        if (getQueryString('wea_link_keep_basic_intercept') === '0') {
            return true;
        }

        //返回当前模块是否授权，由于主框架有记住上次访问地址跳转功能，需要在内部判断
        return flag;
    }

    //模块禁用判断与跳转--范围：应用管理中的module
    public getModuleDisabledByUrl(customReturnValue?: string) {//是否返回对应的禁用类型，团队、个人禁用
        let currentModule = this.getCurrentModuleByMap('disableModules');
        //以下地址放行
        if (this.pathMapMathed(appWhiteMap)) {
            return false;
        }
        if (getQueryString('wea_link_keep_basic_intercept') === '0') {
            return false;
        }
        //返回禁用结果供主框架使用，由于主框架有记住上次访问地址跳转功能，需要在内部判断
        return window.TEAMS.isDisabledModule(currentModule, customReturnValue);
    }
    public getModuleInstallByUrl() {
        let currentModule = this.getCurrentModuleByMap('displayModules');
        //以下地址放行
        if (this.pathMapMathed(appWhiteMap)) {
            return true;
        }
        if (!currentModule) {
            return true
        }
        //返回禁用结果供主框架使用，由于主框架有记住上次访问地址跳转功能，需要在内部判断
        return window.TEAMS.isInstalledModule(currentModule);
    }





    //根据url判断模块禁用与license付费以及未安装状态
    public getModuleStatusByUrl(url: string) {
        let currentLicenseModule = this.getCurrentModuleByMap('displayModules', url);
        let currentDisabledModule = this.getCurrentModuleByMap('standardModules', url);
        let licenseFlag = true;
        let moduleDisabledFlag = true;
        let installFlag = true;

        //license判断，copy getModulePurchasedByUrl

        //能获取到具体module且当前module未购买
        if (currentLicenseModule && !window.TEAMS?.isPurchasedModule(currentLicenseModule)) {
            licenseFlag = false
        }
        // im模块im和emmsg满足一个即展示
        if (currentLicenseModule === 'im' && (window.TEAMS?.isPurchasedModule?.('im') || window.TEAMS?.isPurchasedModule?.('emmsg'))) {
            licenseFlag = true;
        }
        // 未安装
        if (currentLicenseModule && !window.TEAMS?.isInstallModule(currentDisabledModule)) {
            installFlag = true;
        }
        // 以下地址放行
        if (this.pathMapMathed(licenseWhiteMap, url)) {
            licenseFlag = true;
            installFlag = true;
        }

        /////////////////////////////////////////////////////
        /////////////////////////////////////////////////////

        //禁用模块判断 copy getModuleDisabledByUrl
        //以下地址放行
        if (this.pathMapMathed(appWhiteMap, url)) {
            moduleDisabledFlag = false;
        } else {
            //返回禁用结果供主框架使用，由于主框架有记住上次访问地址跳转功能，需要在内部判断
            moduleDisabledFlag = window.TEAMS.isDisabledModule(currentDisabledModule);
        }


        return {
            isPurchasedLicense: licenseFlag,
            isDisabledModule: moduleDisabledFlag,
            isInstall: installFlag
        }
    }

    //从url中获取langType设置到cookie中
    private setUrlLangType() {
        const urlLangType = getQueryString("layout_tenant_langType");
        if (urlLangType) {
            clearOneCookie("langType");
            setCookie("langType", urlLangType)
            let href = window.location.href;
            let langTypeIndex = href.indexOf('layout_tenant_langType=');
            href = href.substr(0, langTypeIndex - 1);
            window.history.replaceState(null, null, href);
        }
    }

    private lockPageDom;
    private contentDom;
    private showPcLock() {
        if (!this.pcLocked) {
            checkWeappUi(() => {
                window.weappUtils?.corsImport?.("@weapp/layout").then(({ PCLockMaskCom }) => {
                    this.lockPageDom = document.createElement('div');
                    window.ReactDOM.render(React.createElement(PCLockMaskCom, {}), this.lockPageDom);
                    document.body.appendChild(this.lockPageDom);
                    let timer = setTimeout(() => {
                        if (this.pcLocked) {
                            this.contentDom = document.body.removeChild(document.querySelector("#root"));
                        }
                        clearTimeout(timer)
                    }, 3000)
                    this.pcLocked = true
                })
            })
        }
    }
    public lockPage(callback?: Function) {
        let inPCClient = /weapp-pc/i.test(window.navigator.userAgent)
        let client = getClientType();
        this.request({
            url: `/api/basiconline/online/lockPage?dtu=${inPCClient ? 'app-pc' : 'pc'}&touchDtu=${client}`,
            type: "GET",
            callback: (responseText: any) => {
                let res = JSON.parse(responseText);
                const { status, data, msg } = res;
                if (status) {
                    callback?.();
                }
            }
        });
    }

    public updateCache(field: string, value: any) {
        const checkExist = (object: any, field: string) => {
            if (!(object[field] instanceof Object)) {
                object[field] = {};
            }
        }
        const updateObject = (obj: any, field: string, value: any) => {
            const fields = field?.split(".") || [];
            fields.forEach((itemField, index) => {
                if (index === fields.length - 1) {
                    obj[itemField] = value;
                } else {
                    checkExist(obj, itemField)
                    obj = obj[itemField]
                }
            })
        }

        let lsTEAMSKey = 'E10_TEAMS_LOCAL';
        let localTEAMS = localStorage.getItem(lsTEAMSKey);
        try {
            localTEAMS = JSON.parse(localTEAMS);
        } catch (e) {
            localTEAMS = window.TEAMS;
        }

        updateObject(localTEAMS, field, value);
        updateObject(window.TEAMS, field, value);

        window.localStorage.setItem(lsTEAMSKey, JSON.stringify(localTEAMS));

    }

    // clearFavicon = () => {
    //     document.querySelector('link[rel="icon"]')?.setAttribute('href', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9oFFAADATTAuQQAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAEklEQVQ4y2NgGAWjYBSMAggAAAQQAAGFP6pyAAAAAElFTkSuQmCC');
    // }
}


const instance = new Passport();
export default instance
window.addEventListener('message', function (event) {
    if (event.data?.action === 'get_weaver_token') {
        document.querySelector('#nanshanIframe')?.contentWindow?.postMessage({ key: 'Token', value: 'fdsafasfasfas' }, '*');
    }
});